/** in this Component Grievance data is displaying in the table */

import React, { useState, useEffect } from "react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Search,
  X,
  FileText,
  Image,
  Download,
  RefreshCcw,
  CircleCheckBig,
  UserPlus,
  FilterX,
  ListChecks,
  Clock,
} from "lucide-react";
import { Viewicon } from "../../../Components/IconComponents";
import { getData } from "../../../Services/ProfileServices";
import {
  fetchGrievanceData,
  getbarches,
  getThemeURL,
  getallBanksByRole,
  acceptAfterEsclation,
  reopenAfterClosed,
  getAllSLA,
  getUsersByUserLevelExceptCurrent,
  getHolidayList,
  getIssueTypes,
  // getUsersGrievance,
  departmentslist,
  // getL1UserList,
  getBranchUserList,
  assignNewL1User,
  bulkAssign,
  userListForSupportAdmin,
  assignNewL2User,
  getUsersByLevels,
} from "../../../Services/EndPoints";
import { postDataWithBody } from "../../../Services/Services";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { Sheet, FileText as FileTextIcon, ShieldAlert, Info } from "lucide-react";
import ExpandableTablegrievancetable from "./ExpandableTablegrievancetable";
import Loader from "react-spinner-loader"; // Add this import

const GrievanceTable = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false); // Add loader state
  // ADD these new state variables after your existing states (around line 40)
const [selectedGrievances, setSelectedGrievances] = useState([]);
// Add these state variables
const [tempFromDate, setTempFromDate] = useState("");
const [tempToDate, setTempToDate] = useState("");
// Add this with your other state declarations (around line 40)
const [userDepartmentId, setUserDepartmentId] = useState(null);
const [showBulkAssignModal, setShowBulkAssignModal] = useState(false);
const [bulkAssignUsersList, setBulkAssignUsersList] = useState([]);
const [selectedBulkAssignUser, setSelectedBulkAssignUser] = useState("");
const [isBulkAssigning, setIsBulkAssigning] = useState(false);
const [isDepartmentAdmin, setIsDepartmentAdmin] = useState(false);
// ADD this new state variable with other state declarations (around line 40)
const [showSupportAdminAssignModal, setShowSupportAdminAssignModal] = useState(false);
const [selectedGrievanceForSupportAdminAssign, setSelectedGrievanceForSupportAdminAssign] = useState(null);
const [supportAdminUsersList, setSupportAdminUsersList] = useState([]);
const [selectedSupportAdminUser, setSelectedSupportAdminUser] = useState("");
const [supportAdminAssignmentDescription, setSupportAdminAssignmentDescription] = useState("");
const [isSupportAdminAssigning, setIsSupportAdminAssigning] = useState(false);
const [isSupportAdmin, setIsSupportAdmin] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
const [selectedGrievanceForAssign, setSelectedGrievanceForAssign] = useState(null);
const [l1UsersList, setL1UsersList] = useState([]);
const [selectedL1User, setSelectedL1User] = useState("");
const [assignmentDescription, setAssignmentDescription] = useState("");
const [isAssigning, setIsAssigning] = useState(false);
// eslint-disable-next-line no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [userProfile, setUserProfile] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("Status - All");
  const [filteredComplaints, setFilteredComplaints] = useState([]);
  const [complaints, setComplaints] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLoaded, setIsLoaded] = useState(false);
  const [userId, setUserId] = useState(null);
  const [totalComplaints, setTotalComplaints] = useState(0);
  const [pendingComplaints, setPendingComplaints] = useState(0);
  const [issueTypes, setIssueTypes] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All Categories");
  // eslint-disable-next-line no-unused-vars
  const [userLevel, setUserLevel] = useState("");

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState("");

  // Confirmation Modal states
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedGrievance, setSelectedGrievance] = useState(null);
  const [isAccepting, setIsAccepting] = useState(false);
  const [selectedAction, setSelectedAction] = useState(""); // "accept" or "reopen"

  // Bank and Branch filter states
  const [selectedBankId, setSelectedBankId] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [filteredBranches, setFilteredBranches] = useState([]);
  const [banksList, setBanksList] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [isAdmin, setIsAdmin] = useState(true);
  const [reopenRemarks, setReopenRemarks] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [fileErrors, setFileErrors] = useState([]);
  const [reopenedTo, setReopenedTo] = useState("");
  const [userNames, setUserNames] = useState([]);
  const [priorities, setPriorities] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [currentUser, setCurrentUser] = useState(null);
  const [holidays, setHolidays] = useState([]);
const [isLoadingHolidays, setIsLoadingHolidays] = useState(false);
const [isRefreshing, setIsRefreshing] = useState(false);
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
// eslint-disable-next-line no-unused-vars
const [selectedUser, setSelectedUser] = useState("");
const [priorityLevel, setPriorityLevel] = useState("");
// eslint-disable-next-line no-unused-vars
const [reportedByUsers, setReportedByUsers] = useState([]);
// eslint-disable-next-line no-unused-vars
const [resolvedByUsers, setResolvedByUsers] = useState([]);
const [allDepartments, setAllDepartments] = useState([]); // Add this state
// Add these to your existing state declarations
const [selectedDepartment, setSelectedDepartment] = useState("");
const [resolvedBy, setResolvedBy] = useState(""); // Separate from selectedUser
const [reportedBy, setReportedBy] = useState(""); // Separate from selectedUser

  const statusOptions = [
  "Status - All",
  "Open",
  "In Progress",
  // "Issue Pending at User Level", // NEW
  // "Issue Pending at External Vendor", // NEW
  "Resolved",
 // "Closed",
  // "Rejected", // Keep this commented if you don't want it in the filter
];

  const clearAllFilters = () => {
  setSearchQuery("");
  setStatusFilter("Status - All");
  setSelectedCategory("All Categories");
  setSelectedBankId("");
  setSelectedBranch("");
  setFilteredBranches([]);
  setFromDate("");
  setToDate("");
  setTempFromDate(""); // Add this
  setTempToDate(""); // Add this
  setPriorityLevel("");
  setSelectedDepartment("");
  setReportedBy("");
  setResolvedBy("");
  
  toast.success("All filters cleared", {
    position: "top-center",
    autoClose: 2000,
  });
};

const handleApplyDateFilter = () => {
  const today = new Date();
  
  
  // Check if dates are future dates
  const fromDateObj = new Date(tempFromDate);
  const toDateObj = new Date(tempToDate);
  
  if (tempFromDate && fromDateObj > today) {
    toast.error("From date cannot be in the future", {
      position: "top-center",
      autoClose: 2000,
    });
    setTempFromDate("");
    return;
  }
  
  if (tempToDate && toDateObj > today) {
    toast.error("To date cannot be in the future", {
      position: "top-center",
      autoClose: 2000,
    });
    setTempToDate("");
    return;
  }
  
  // Check if from date is after to date
  if (tempFromDate && tempToDate && fromDateObj > toDateObj) {
    toast.error("From date cannot be after To date", {
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }
  
  setFromDate(tempFromDate);
  setToDate(tempToDate);
  
  toast.success("Date filter applied", {
    position: "top-center",
    autoClose: 2000,
  });
};
// Remove the validation from onChange handlers - let users type freely
const handleFromDateChange = (e) => {
  const value = e.target.value;
  setTempFromDate(value);
  
  // Clear the to date if it's earlier than the new from date
  if (tempToDate && value > tempToDate) {
    setTempToDate("");
  }
};

const handleToDateChange = (e) => {
  const value = e.target.value;
  setTempToDate(value);
};
const validateDateOnBlur = (dateType) => {
  const today = new Date();
  
  if (dateType === 'from' && tempFromDate) {
    const fromDate = new Date(tempFromDate);
    // Only show error if date is strictly after today (tomorrow or later)
    if (fromDate > today) {
      toast.error("From date cannot be in the future", {
        position: "top-center",
        autoClose: 2000,
      });
      setTempFromDate("");
    }
  }
  
  if (dateType === 'to' && tempToDate) {
    const toDate = new Date(tempToDate);
    // Only show error if date is strictly after today (tomorrow or later)
    if (toDate > today) {
      toast.error("To date cannot be in the future", {
        position: "top-center",
        autoClose: 2000,
      });
      setTempToDate("");
    } else if (tempFromDate && new Date(tempToDate) < new Date(tempFromDate)) {
      toast.error("To date cannot be earlier than From date", {
        position: "top-center",
        autoClose: 2000,
      });
      setTempToDate("");
    }
  }
};
// Update your handleRefresh function
const handleRefresh = async () => {
  setIsRefreshing(true);
  try {
    // clearAllFilters();
    
    // Reset to first page
    setCurrentPage(1);
    
    // Fetch fresh data
    await getAllGrievanceData();
    
    toast.success("Data refreshed successfully", {
      position: "top-center",
      autoClose: 2000,
    });
  } catch (error) {
    console.error("Error refreshing data:", error);
    toast.error("Failed to refresh data", {
      position: "top-center",
      autoClose: 2000,
    });
  } finally {
    setIsRefreshing(false);
  }
};

 // Function to fetch holidays for the selected bank
const fetchHolidays = async (bankCode) => {
  if (!bankCode) {
    console.log("No bankId provided for holiday fetch");
    setHolidays([]);
    return;
  }

  console.log("Starting holiday fetch for bank:", bankCode);
  setIsLoadingHolidays(true);
  
  try {
    // Build payload directly from userProfile
    let admin_role = "U"; // default value

    if (userProfile) {
      if (userProfile[0].is_admin === true) {
        admin_role = "HO";
      } else if (userProfile[0].role_name === "SUPER ADMIN") {
        admin_role = "SA";
      }
    }

    const payload = {
      admin_role: admin_role,
      bank_code: bankCode || null,
      // branch_code: userProfile[0]?.branch_code || null,
    };
    
    console.log(bankCode,"bankcodebankcode")

    console.log("Holiday API Payload:", payload);

    // Use postDataWithBody instead of getData
    const response = await postDataWithBody(getHolidayList, payload, {});
    console.log("Holiday API response:", response);
    
    if (response && Array.isArray(response)) {
      // Filter holidays for the selected bank and active status
      const bankHolidays = response.filter(holiday => {
        const isActive = holiday.status === 1 || holiday.status === "1" || holiday.activeStatus === true;
        const isForSelectedBank = holiday.bankCode === bankCode || 
                                 holiday.bankCode?.toString() === bankCode.toString() ||
                                 holiday.bankCode === bankCode || 
                                 holiday.bankCode?.toString() === bankCode.toString();
        
        console.log(`Holiday: ${holiday.fromDate} to ${holiday.toDate}, Active: ${isActive}, ForBank: ${isForSelectedBank}`);
        
        return isActive && isForSelectedBank;
      });
      
      console.log("Filtered bank holidays:", bankHolidays.length, bankHolidays);
      setHolidays(bankHolidays);
    } else {
      console.log("Invalid holiday response format");
      setHolidays([]);
    }
  } catch (error) {
    console.error("Error fetching holidays:", error);
    setHolidays([]);
  } finally {
    setIsLoadingHolidays(false);
    console.log("Holiday fetch completed");
  }
};
// Function to check if a date is a holiday
const isHoliday = (date) => {
  if (!holidays.length || !selectedGrievance) {
    console.log("No holidays or selected grievance available");
    return false;
  }
  
  const bankCode = getBankIdFromGrievance(selectedGrievance);
  if (!bankCode) {
    console.log("No bankId available for holiday checking");
    return false;
  }
  
  const checkDate = new Date(date);
  console.log("Checking holiday for date:", checkDate, "Bank ID:", bankCode);
  
  return holidays.some(holiday => {
    try {
      const holidayFrom = new Date(holiday.fromDate);
      const holidayTo = new Date(holiday.toDate);
      
      holidayFrom.setHours(0, 0, 0, 0);
      holidayTo.setHours(23, 59, 59, 999);
      
      const comparisonDate = new Date(checkDate);
      comparisonDate.setHours(12, 0, 0, 0);
      
      const isHolidayDate = comparisonDate >= holidayFrom && comparisonDate <= holidayTo;
      
      if (isHolidayDate) {
        console.log("Date falls on holiday:", holiday.fromDate, "to", holiday.toDate);
      }
      
      return isHolidayDate;
    } catch (error) {
      console.error("Error checking holiday date:", error);
      return false;
    }
  });
};

// Function to check if a date is Sunday
const isSunday = (date) => {
  return date.getDay() === 0;
};

// Function to add days excluding Sundays and holidays
const addDaysExcludingSundaysAndHolidays = (startDate, daysToAdd) => {
  let resultDate = new Date(startDate);
  let addedDays = 0;

  while (addedDays < daysToAdd) {
    resultDate.setDate(resultDate.getDate() + 1);
    
    // Skip Sundays and holidays
    if (!isSunday(resultDate) && !isHoliday(resultDate)) {
      addedDays++;
    }
  }

  return resultDate;
};

// Function to add hours excluding Sundays and holidays
const addHoursExcludingSundaysAndHolidays = (startDate, hoursToAdd) => {
  let resultDate = new Date(startDate);
  let addedHours = 0;

  while (addedHours < hoursToAdd) {
    resultDate.setHours(resultDate.getHours() + 1);
    addedHours++;

    // If we encounter a Sunday or holiday, skip to next working day
    if (isSunday(resultDate) || isHoliday(resultDate)) {
      // Move to next day
      resultDate.setDate(resultDate.getDate() + 1);
      resultDate.setHours(9, 0, 0, 0); // Start at 9 AM next working day
      
      // Keep skipping until we find a working day
      while (isSunday(resultDate) || isHoliday(resultDate)) {
        resultDate.setDate(resultDate.getDate() + 1);
      }
    }
  }

  return resultDate;
};

// Function to add minutes excluding Sundays and holidays
const addMinutesExcludingSundaysAndHolidays = (startDate, minutesToAdd) => {
  let resultDate = new Date(startDate);
  let addedMinutes = 0;

  while (addedMinutes < minutesToAdd) {
    resultDate.setMinutes(resultDate.getMinutes() + 1);
    addedMinutes++;

    // If we encounter a Sunday or holiday, skip to next working day
    if (isSunday(resultDate) || isHoliday(resultDate)) {
      // Move to next day
      resultDate.setDate(resultDate.getDate() + 1);
      resultDate.setHours(9, 0, 0, 0); // Start at 9 AM next working day
      
      // Keep skipping until we find a working day
      while (isSunday(resultDate) || isHoliday(resultDate)) {
        resultDate.setDate(resultDate.getDate() + 1);
      }
    }
  }

  return resultDate;
};

// Keep this as fallback when no bank is selected
const addDaysExcludingSundays = (startDate, daysToAdd) => {
  let resultDate = new Date(startDate);
  let addedDays = 0;

  while (addedDays < daysToAdd) {
    resultDate.setDate(resultDate.getDate() + 1);
    if (resultDate.getDay() !== 0) { // exclude Sundays
      addedDays++;
    }
  }

  return resultDate;
};

useEffect(()=>{
  getUsersLists();
  getAllDepartments();
},[])


// Add this useEffect to extract department_id when userProfile changes
useEffect(() => {
  if (userProfile && userProfile[0]) {
    // Extract department_id from user profile
    // Adjust the path based on your actual API response structure
    const deptId = userProfile[0].department_id;
    setUserDepartmentId(deptId);
    
    console.log("User Department ID:", deptId);
  }
}, [userProfile]);


// Add this helper function after your state declarations
// eslint-disable-next-line react-hooks/exhaustive-deps
const shouldApplyDepartmentFilter = () => {
  if (!userProfile || !userProfile[0] || !userDepartmentId) {
    return false;
  }
  
  const userLevel = userProfile[0].user_level;
  const isSupportAdmin = userProfile[0].is_dep_admin === true;
  
  // Apply filter only for Support Admin, L2, and L3 users
  return isSupportAdmin || userLevel === 'L2' || userLevel === 'L3';
};

// Fetch holidays when selected grievance changes
useEffect(() => {
  if (selectedGrievance?.originalData?.bankCode) {
    fetchHolidays(selectedGrievance.originalData.bankCode);
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedGrievance]);

  const fetchIssueTypes = async () => {
    try {
      let request = ["GRV_CAT_TYPE"];
      const response = await postDataWithBody(getIssueTypes, request, {});
      if (Array.isArray(response)) {
        setIssueTypes(response);
      }
    } catch (error) {
      console.error("Error fetching issue types:", error);
    }
  };

  useEffect(() => {
    fetchIssueTypes();
  }, []);

  // Modal functions
  // eslint-disable-next-line no-unused-vars
  const openModal = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalTitle("");
    setModalContent("");
  };

  // Update the openConfirmationModal function to fetch holidays
const openConfirmationModal = async (grievance, action) => {
  setSelectedGrievance(grievance);
  setSelectedAction(action);

  // Reset file selection when modal opens
  setSelectedFiles([]);
  setFileErrors([]);
  
  // Fetch holidays immediately when modal opens
  const bankCode = getBankIdFromGrievance(grievance);
  console.log("Opening modal - Bank ID:", bankCode);
  
  if (bankCode) {
    console.log("Fetching holidays for bank:", bankCode);
    await fetchHolidays(bankCode);
  } else {
    console.log("No bankId found for grievance:", grievance.id);
  }
  
  // Fetch user names for L1 level with bank and branch codes
  if (action === "reopen") {
    await fetchUserNames(grievance); // Pass grievance as parameter
  }
  
  setShowConfirmationModal(true);
};

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
    setSelectedGrievance(null);
    setSelectedAction("");
    setIsAccepting(false);
    // Reset reopen specific states
    setReopenRemarks("");
    setSelectedFiles([]);
    setFileErrors([]);
    setReopenedTo("");
  };

  const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  const newFiles = [];
  let hasErrors = false;
  let errorMessage = "";

  // Check total file count - if already have 5 files, reject all
  if (selectedFiles.length >= 5) {
    toast.error("Maximum 5 files allowed. Please remove some files first.", {
      position: "top-center",
      autoClose: 3000,
    });
    e.target.value = "";
    return;
  }

  // Check if adding these files would exceed the limit
  const remainingSlots = 5 - selectedFiles.length;
  if (files.length > remainingSlots) {
    toast.error(`You can only upload ${remainingSlots} more file(s). Please select fewer files.`, {
      position: "top-center",
      autoClose: 3000,
    });
    e.target.value = "";
    return;
  }

  files.forEach((file, index) => {
    // Check file size (1MB = 1048576 bytes)
    if (file.size > 1048576) {
      hasErrors = true;
      errorMessage = `"${file.name}" exceeds 1MB size limit`;
      return;
    }

    // Check file type
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/gif",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      hasErrors = true;
      errorMessage = `"${file.name}" has unsupported file type. Allowed: PNG, JPG, JPEG, GIF, PDF`;
      return;
    }

    // Check if file already exists
    if (
      selectedFiles.some(
        (f) => f.file.name === file.name && f.file.size === file.size
      )
    ) {
      hasErrors = true;
      errorMessage = `"${file.name}" is already selected`;
      return;
    }

    // Add valid file
    newFiles.push({
      id: Date.now() + index,
      file: file,
      name: file.name,
      size: file.size,
      type: file.type,
      uploadDate: new Date().toLocaleString(),
    });
  });

  // Show error if any file failed validation
  if (hasErrors && errorMessage) {
    toast.error(errorMessage, {
      position: "top-center",
      autoClose: 3000,
    });
    
    // If no valid files were found, clear input and return
    if (newFiles.length === 0) {
      e.target.value = "";
      return;
    }
  }

  // Update state with new files
  if (newFiles.length > 0) {
    setSelectedFiles((prev) => [...prev, ...newFiles]);
    
    // Show success message for successfully added files
    if (newFiles.length === 1) {
      toast.success(`"${newFiles[0].name}" added successfully`, {
        position: "top-center",
        autoClose: 2000,
      });
    } else if (newFiles.length > 1) {
      toast.success(`${newFiles.length} files added successfully`, {
        position: "top-center",
        autoClose: 2000,
      });
    }
  }

  // Clear the input
  e.target.value = "";
};

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#e8f4f8";
    e.currentTarget.style.borderColor = "#2c7a95";
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#f8fbfc";
    e.currentTarget.style.borderColor = "#4899B7";
  };

  const handleDrop = (e) => {
  e.preventDefault();
  e.currentTarget.style.backgroundColor = "#f8fbfc";
  e.currentTarget.style.borderColor = "#4899B7";

  const files = Array.from(e.dataTransfer.files);
  
  // Check if we can accept more files
  if (selectedFiles.length >= 5) {
    toast.error("Maximum 5 files allowed. Please remove some files first.", {
      position: "top-center",
      autoClose: 3000,
    });
    return;
  }

  if (files.length > 0) {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.files = e.dataTransfer.files;
    input.onchange = (event) => handleFileChange(event);
    input.click();
  }
};

  const removeFile = (fileId) => {
  const fileToRemove = selectedFiles.find(file => file.id === fileId);
  setSelectedFiles((prev) => prev.filter((file) => file.id !== fileId));
  
  if (fileToRemove) {
    toast.info(`"${fileToRemove.name}" removed`, {
      position: "top-center",
      autoClose: 2000,
    });
  }
};

  const clearAllFiles = () => {
  setSelectedFiles([]);
  toast.info("All files cleared", {
    position: "top-center",
    autoClose: 2000,
  });
};


// Add this function to fetch L1 users
const fetchL1UsersForAssignment = async (bankCode, branchCode) => {
  try {
    const url = getBranchUserList
      .replace("USERLEVEL", "L1")
      .replace("BankCode", bankCode)
      .replace("BranchCode", branchCode);
    
    const response = await getData(url);
    
    if (response && Array.isArray(response)) {
      // Filter active users
      const activeUsers = response.filter(user => 
        user.status !== false && !user.is_deleted
      );
      setL1UsersList(activeUsers);
    } else {
      setL1UsersList([]);
    }
  } catch (error) {
    console.error("Error fetching L1 users for assignment:", error);
    toast.error("Failed to load L1 users", {
      position: "top-center",
      autoClose: 2000,
    });
    setL1UsersList([]);
  }
};

// Add this function to open the assign modal
const openAssignModal = async (grievance) => {
  setSelectedGrievanceForAssign(grievance);
  setSelectedL1User("");
  setAssignmentDescription("");
  
  // Get bankCode and branchCode from the grievance
  const bankCode = grievance.originalData?.bankCode;
  const branchCode = grievance.originalData?.branchCode;
  
  if (bankCode && branchCode) {
    await fetchL1UsersForAssignment(bankCode, branchCode);
  } else {
    toast.error("Bank or Branch information missing", {
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }
  
  setShowAssignModal(true);
};

// Add this function to close the assign modal
const closeAssignModal = () => {
  setShowAssignModal(false);
  setSelectedGrievanceForAssign(null);
  setSelectedL1User("");
  setAssignmentDescription("");
  setL1UsersList([]);
};

// Add this function to handle the assignment submission
const handleAssignSubmit = async () => {
  if (!selectedL1User) {
    toast.error("Please select an L1 user", {
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }
  
  if (!assignmentDescription.trim()) {
    toast.error("Please provide assignment description", {
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }
  
  try {
    setIsAssigning(true);
    setLoader(true);
    
    const formData = new FormData();
    
    // Create the assignment payload
    const assignmentData = {
      grievance_id: selectedGrievanceForAssign.originalData.id,
      reassigned_by_user: userId,
      new_l1_user_id: parseInt(selectedL1User),
      reassignment_description: assignmentDescription.trim()
    };
    
    // Append as JSON string
    formData.append('grievance', JSON.stringify(assignmentData));
    
    console.log('Assignment payload:', assignmentData);
    
    // Call the API
    const assignmentCall = await postDataWithBody(
      assignNewL1User,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    
    console.log('Assignment response:', assignmentCall);
    
    toast.success(
      `Ticket ${selectedGrievanceForAssign.id} assigned successfully`,
      {
        position: "top-center",
        autoClose: 3000,
      }
    );
    
    // Close modal and refresh data
    closeAssignModal();
    getAllGrievanceData();
    
  } catch (error) {
    console.error("Error assigning ticket:", error);
    toast.error("Failed to assign ticket. Please try again.", {
      position: "top-center",
      autoClose: 3000,
    });
  } finally {
    setIsAssigning(false);
    setLoader(false);
  }
};

// Helper function to get user display name
const getUserDisplayName = (user) => {
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  } else if (user.first_name) {
    return user.first_name;
  } else {
    return user.user_name || 'Unknown User';
  }
};

  const getFileIcon = (fileType) => {
    if (fileType.includes("image")) return <Image size={16} />;
    if (fileType.includes("pdf")) return <FileText size={16} />;
    return <FileTextIcon size={16} />;
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  // Status mapping - assuming status IDs map to these values
const getStatusFromId = (statusId) => {
  const statusMap = {
    837: "Open",
    838: "In Progress",
    839: "Hold",
    840: "Resolved",
    841: "Closed",
    842: "Rejected",
    843: "In progress someone",
    844: "Resolved someone",
    845: "Escalated to L2",
    846: "Accept",
    847: "Accepted someone",
    850: "Issue Pending at User Level", // NEW
    851: "Issue Pending at External Vendor", // NEW
  };
  return statusMap[statusId] || "Open";
};

    // Transform grievanceStatusMapEntities with status text
const transformGrievanceStatusEntities = (grievanceStatusMapEntities) => {
    if (!grievanceStatusMapEntities || !Array.isArray(grievanceStatusMapEntities)) {
        return [];
    }
    
    return grievanceStatusMapEntities.map(entity => ({
        ...entity, // Keep all original properties (id, createdBy, grievanceId, createdOn, status)
        statusText: getStatusFromId(entity.status) // Add readable status text
    }));
};

// Add this function after transformGrievanceStatusEntities
const processSortedListData = (sortedListData) => {
    return sortedListData.map(item => ({
        ...item,
        grievanceStatusMapEntities: transformGrievanceStatusEntities(item.grievanceStatusMapEntities)
    }));
};

  //dd-mm-yyyy date format
  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = String(date.getFullYear()).toString();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");

    const formattedTime = `${formattedHours}:${minutes} ${ampm}`;

    return `${dd}-${mm}-${yyyy} ${formattedTime}`;
  };

 
  useEffect(() => {
    fetchUserProfile();
  }, []);

//   const downloadPDF = async () => {
//   try {
//     const doc = new jsPDF("l", "pt", "a4");
//     let currentY = 50;
 
//     let fontName = "Helvetica";
//     doc.setFont(fontName);
//     doc.setFontSize(13);
 
//     const pdfTitle = "Grievance Report";
 
//     const pageWidth = doc.internal.pageSize.width;
//     const xOffset = pageWidth / 2;
//     doc.text(pdfTitle, xOffset, currentY, { align: "center" });
//     currentY += 30;
 
//     // Define consistent column widths for all tables - UPDATED to include Reported By
//     const columnStyles = {
//       0: { cellWidth: 70 },   // Ticket ID
//       1: { cellWidth: 75 },   // Bank Name
//       2: { cellWidth: 60 },   // Branch Name
//       3: { cellWidth: 90 },   // Incident Date
//       4: { cellWidth: 65 },   // Reported By (NEW)
//       5: { cellWidth: 70 },   // Assigned Department
//       6: { cellWidth: 55 },   // Assigned To
//       7: { cellWidth: 48 },   // Category
//       8: { cellWidth: 48 },   // Sub Category
//       9: { cellWidth: 48 },   // Escalation Level
//       10: { cellWidth: 45 },  // Priority
//       11: { cellWidth: 42 },  // Status
//       12: { cellWidth: 85 }   // Status Updated
//     };
 
//     // Define consistent header padding - UPDATED to include Reported By
//     const headerPaddings = {
//       0: { top: 5, right: 5, bottom: 5, left: 18 },   // Ticket ID
//       1: { top: 5, right: 20, bottom: 5, left: 55 },  // Bank Name  
//       2: { top: 5, bottom: 5, left: 22 },             // Branch Name
//       3: { top: 5, bottom: 5, left: 18 },             // Incident Date
//       4: { top: 5, bottom: 5, left: 20 },             // Reported By (NEW)
//       5: { top: 5, right: 8, bottom: 5, left: 17 },    // Assigned Department
//       6: { top: 5, right: 8, bottom: 5, left: 15 },   // Assigned To
//       7: { top: 5, right: 6, bottom: 5, left: 13 },   // Category
//       8: { top: 5, right: 6, bottom: 5, left: 10 },   // Sub Category
//       9: { top: 5, right: 10, bottom: 5, left: 8 },    // Escalation Level
//       10: { top: 5, right: 15, bottom: 5, left: 4 },   // Priority
//       11: { top: 5, right: 3, bottom: 5, left: 1 },   // Status
//       12: { top: 5, right: 6, bottom: 5, left: 8 }    // Status Updated
//     };
 
//     // Add single header row for the entire table - UPDATED to include Reported By
//     const allHeaders = [
//       "Ticket ID", "Bank Name", "Branch Name", "Issue Reported Date & Time",
//       "Reported By", "Support Team", "Assigned To", "Category", "Sub Category",
//       "Escalation Level", "Priority", "Status", "Status Updated Date & Time"
//     ];
 
//     doc.autoTable({
//       head: [allHeaders],
//       body: [], // Empty body for header only
//       startY: currentY,
//       theme: "grid",
//       headStyles: {
//         fillColor: [24, 163, 160],
//         textColor: [255, 255, 255],
//         fontStyle: "bold",
//         halign: "center",
//         fontSize: 8,
//       },
//       didParseCell: function(data) {
//         if (data.row.section === 'head') {
//           if (headerPaddings[data.column.index]) {
//             data.cell.styles.cellPadding = headerPaddings[data.column.index];
//           }
//         }
//       },
//       columnStyles: columnStyles,
//       margin: { left: 20, right: 20 }, // REDUCED from 50 to 20
//     });
 
//     currentY = doc.lastAutoTable.finalY;
 
//     // Process each grievance
//     for (let i = 0; i < filteredComplaints.length; i++) {
//       const grievance = filteredComplaints[i];
     
//       // Check if we need a new page
//       if (currentY > 700) {
//         doc.addPage();
//         currentY = 50;
       
//         // Re-add header on new page
//         doc.autoTable({
//           head: [allHeaders],
//           body: [],
//           startY: currentY,
//           theme: "grid",
//           headStyles: {
//             fillColor: [24, 163, 160],
//             textColor: [255, 255, 255],
//             fontStyle: "bold",
//             halign: "center",
//             fontSize: 8,
//           },
//           didParseCell: function(data) {
//             if (data.row.section === 'head') {
//               if (headerPaddings[data.column.index]) {
//                 data.cell.styles.cellPadding = headerPaddings[data.column.index];
//               }
//             }
//           },
//           columnStyles: columnStyles,
//           margin: { left: 20, right: 20 }, // REDUCED from 50 to 20
//         });
//         currentY = doc.lastAutoTable.finalY;
//       }
 
//       // Check if this grievance has previous tickets
//       const oldGrievances = grievance.originalData?.oldGrievanceInformationEntity || [];
//       const hasOldGrievances = oldGrievances.length > 0;
 
//       // Main grievance data row with consistent column widths - UPDATED to include Reported By
//       const mainData = [[
//         grievance.id || "N/A",
//         grievance.bank || "N/A",
//         grievance.branch || "N/A",
//         grievance.date || "N/A",
//         grievance.requesterBy || "N/A", // NEW - Reported By
//         grievance.handler || "N/A",
//         grievance.originalData?.assignToUserName || "N/A",
//         grievance.issueTypeName || "N/A",
//         grievance.issueTypeSubCatName || "N/A",
//         grievance.userLevels || "N/A",
//         grievance.criticality || "N/A",
//         grievance.status || "N/A",
//         grievance.lastStatusUpdated || "N/A"
//       ]];
 
//       doc.autoTable({
//         head: [], // No header for data rows
//         body: mainData,
//         startY: currentY,
//         theme: "grid",
//         bodyStyles: {
//           fontSize: 7,
//           halign: "left",
//           fillColor: hasOldGrievances ? [220, 248, 198] : [255, 255, 255],
//         },
//         columnStyles: columnStyles, // Use same column widths
//         margin: { left: 20, right: 20 }, // REDUCED from 50 to 20
//       });
 
//       currentY = doc.lastAutoTable.finalY;
 
//       // Previous Tickets Section - only if tickets exist
//       if (oldGrievances.length > 0) {
//         // Check if we need a new page for previous tickets
//         if (currentY > 650) {
//           doc.addPage();
//           currentY = 50;
//         }
 
//         // Previous tickets data - UPDATED to include Reported By
//         const prevData = oldGrievances.map(oldGrievance => {
//           // Get last status updated for old grievances
//           const statusUpdates = oldGrievance.grievanceStatusMapEntities || [];
//           let lastStatusUpdated = "N/A";
         
//           if (statusUpdates.length > 0) {
//             const sortedStatusUpdates = [...statusUpdates].sort((a, b) =>
//               new Date(b.createdOn) - new Date(a.createdOn)
//             );
//             lastStatusUpdated = formatDateTime(sortedStatusUpdates[0].createdOn);
//           }
 
//           return [
//             oldGrievance.grievanceSeqId || 'NA',
//             oldGrievance.bankNameShort || 'NA',
//             oldGrievance.branchNameShort || 'NA',
//             formatDateTime(oldGrievance.ticketDateAndTime || oldGrievance.createdon) || 'NA',
//             oldGrievance.requesterBy || 'NA', // NEW - Reported By
//             oldGrievance.assignedTeamName || 'NA',
//             oldGrievance.assignToUserName || 'NA',
//             oldGrievance.issueTypeName || 'NA',
//             oldGrievance.issueTypeSubCatName || 'NA',
//             oldGrievance.userLevel || 'NA',
//             oldGrievance.priority || 'NA',
//             getStatusFromId(oldGrievance.status) || 'Open',
//             lastStatusUpdated || 'N/A'
//           ];
//         });
 
//         // Add Previous Tickets section title
//         currentY += 10;
//         doc.setFontSize(10);
//         doc.setFont(fontName, 'bold');
//         doc.text(`Ticket Lineage (${oldGrievances.length} Record${oldGrievances.length !== 1 ? 's' : ''})`, 20, currentY); // CHANGED from 50 to 20
//         currentY += 10;
 
//         // Use same headers and column styles for previous tickets
//         doc.autoTable({
//           head: [allHeaders], // Same headers
//           body: prevData,
//           startY: currentY,
//           theme: 'grid',
//           headStyles: {
//             fillColor: [72, 153, 183], // Blue color for previous tickets header
//             textColor: [255, 255, 255],
//             fontStyle: 'bold',
//             halign: 'center',
//             fontSize: 7,
//             cellPadding: { top: 5, right: 3, bottom: 5, left: 3 }
//           },
//           bodyStyles: {
//             fontSize: 6,
//             fillColor: [248, 249, 250], // Light background for previous tickets data
//             halign: 'left',
//             cellPadding: { top: 4, right: 3, bottom: 4, left: 3 }
//           },
//           columnStyles: columnStyles, // Use same column widths
//           margin: { left: 20, right: 20 } // REDUCED from 50 to 20
//         });
 
//         currentY = doc.lastAutoTable.finalY;
 
//         // Add separator line only if current grievance has previous tickets AND it's not the last grievance
//         if (i < filteredComplaints.length - 1) {
//           currentY += 15;
//           doc.setDrawColor(200, 200, 200);
//           doc.line(20, currentY, pageWidth - 20, currentY); // CHANGED from 50 to 20
//           currentY += 15;
//         }
//       }
//     }
 
//     // Footer section
//     const pageHeight = doc.internal.pageSize.height;
//     const footerHeight = 180;
//     const finalY = doc.lastAutoTable?.finalY || currentY;
 
//     if (finalY + footerHeight > pageHeight) {
//       doc.addPage();
//       currentY = 50;
//     }
 
//     let footerY = pageHeight - 180;
 
//     doc.setFontSize(10);
//     doc.setFont(fontName, "normal");
 
//     // Left side footer items - CHANGED from 50 to 20
//     doc.text("Letter No. :", 20, footerY + 100);
//     doc.text("Date :", 20, footerY + 120);
//     doc.text("Copy :", 20, footerY + 140);
 
//     // Right side footer items
//     doc.text("XXXX", 550, footerY + 100);
//     doc.text("XXXXXXXXX", 550, footerY + 120);
//     doc.text("XXXXXX", 550, footerY + 140);
 
//     // Generate filename with timestamp
//     const now = new Date();
//     const istDate = now.toISOString().split("T")[0].replace(/-/g, "");
//     const hours = now.getHours().toString().padStart(2, "0");
//     const minutes = now.getMinutes().toString().padStart(2, "0");
//     const seconds = now.getSeconds().toString().padStart(2, "0");
//     const istTime = `${hours}${minutes}${seconds}`;
//     const filename = `grievance_report_${istDate}_${istTime}.pdf`;
 
//     doc.save(filename);
//   } catch (error) {
//     console.error("Error generating PDF:", error);
//     toast.error("Error generating PDF. Please try again.");
//   }
// };


// UPDATED downloadPDF function with Resolved By column and proper alignments
// Replace the entire downloadPDF function in your GrievanceTable.jsx file with this code








// ============================================================
// UPDATED downloadPDF function
// Changes:
//   - "Branch Name" merged below "Bank Name" in the same cell
//   - "Sub Category" merged below "Category" in the same cell
//   - Both main rows and previous-ticket (old grievance) rows updated
// ============================================================

const downloadPDF = async () => {
  try {
    const doc = new jsPDF("l", "pt", "a4");
    let currentY = 50;
    const fontName = "Helvetica";
    doc.setFont(fontName);
    doc.setFontSize(13);

    const pageWidth = doc.internal.pageSize.width;
    doc.text("Grievance Report", pageWidth / 2, currentY, { align: "center" });
    currentY += 30;

    // 13 columns — removed Bank/Branch, Support Team, Assigned To, Sub Category
    const columnStyles = {
      0:  { cellWidth: 50  }, // Ticket ID
      1:  { cellWidth: 80  }, // Region Name
      2:  { cellWidth: 98  }, // Ticket Created Date
      3:  { cellWidth: 80  }, // Reported By
      4:  { cellWidth: 60  }, // Resolved By
      5:  { cellWidth: 70  }, // Category
      6:  { cellWidth: 50  }, // Escalation Level
      7:  { cellWidth: 54  }, // Priority
      8:  { cellWidth: 66  }, // Status
      9:  { cellWidth: 100  }, // Status Updated
      10: { cellWidth: 95  }, // Record Updated On
    };

    const allHeaders = [
      "Ticket ID",
      "Region Name",
      "Ticket Created Date & Time",
      "Reported By",
      "Resolved By",
      "Category",
      "Escalation Level",
      "Priority",
      "Status",
      "Status Updated Date & Time",
      "Record Updated On",
    ];

    const renderHeader = (startY) => {
      doc.autoTable({
        head: [allHeaders],
        body: [],
        startY,
        theme: "grid",
        headStyles: {
          fillColor: [24, 163, 160],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          halign: "center",
          fontSize: 7,
        },
        columnStyles,
        margin: { left: 20, right: 20 },
      });
      return doc.lastAutoTable.finalY;
    };

    currentY = renderHeader(currentY);

    for (let i = 0; i < filteredComplaints.length; i++) {
      const grievance = filteredComplaints[i];

      if (currentY > 700) {
        doc.addPage();
        currentY = 50;
        currentY = renderHeader(currentY);
      }

      const oldGrievances =
        grievance.originalData?.oldGrievanceInformationEntity || [];
      const hasOldGrievances = oldGrievances.length > 0;
      const regionName =
        grievance.originalData?.regionName || grievance.bank || "N/A";

      doc.autoTable({
        head: [],
        body: [[
          grievance.id || "N/A",
          regionName,
          grievance.date || "N/A",
          grievance.requesterBy || "N/A",
          grievance.resolvedBy || "Not Yet Resolved",
          grievance.issueTypeName || "N/A",
          grievance.userLevels || "N/A",
          grievance.criticality || "N/A",
          grievance.status || "N/A",
          grievance.lastStatusUpdated || "N/A",
          grievance.updated_on || "N/A",
        ]],
        startY: currentY,
        theme: "grid",
        bodyStyles: {
          fontSize: 7,
          halign: "left",
          fillColor: hasOldGrievances ? [220, 248, 198] : [255, 255, 255],
        },
        columnStyles,
        margin: { left: 20, right: 20 },
      });

      currentY = doc.lastAutoTable.finalY;

      if (oldGrievances.length > 0) {
        if (currentY > 650) {
          doc.addPage();
          currentY = 50;
        }

        const prevData = oldGrievances.map((og) => {
          const statusUpdates = og.grievanceStatusMapEntities || [];
          let lastStatusUpdated = "N/A";
          if (statusUpdates.length > 0) {
            const sorted = [...statusUpdates].sort(
              (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
            );
            lastStatusUpdated = formatDateTime(sorted[0].createdOn);
          }
          const oldRegionName = og.regionName || og.bankNameShort || "N/A";

          return [
            og.grievanceSeqId || "N/A",
            oldRegionName,
            formatDateTime(og.ticketDateAndTime || og.createdon) || "N/A",
            og.requesterBy || "N/A",
            og.resolvedBy || "Not Yet Resolved",
            og.issueTypeName || "N/A",
            og.userLevel || "N/A",
            og.priority || "N/A",
            getStatusFromId(og.status) || "Open",
            lastStatusUpdated,
            formatDateTime(og.updated_on) || "N/A",
          ];
        });

        currentY += 10;
        doc.setFontSize(10);
        doc.setFont(fontName, "bold");
        doc.text(
          `Ticket Lineage (${oldGrievances.length} Record${oldGrievances.length !== 1 ? "s" : ""})`,
          20,
          currentY
        );
        currentY += 10;

        doc.autoTable({
          head: [allHeaders],
          body: prevData,
          startY: currentY,
          theme: "grid",
          headStyles: {
            fillColor: [72, 153, 183],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            halign: "center",
            fontSize: 7,
            cellPadding: { top: 5, right: 3, bottom: 5, left: 3 },
          },
          bodyStyles: {
            fontSize: 6,
            fillColor: [248, 249, 250],
            halign: "left",
            cellPadding: { top: 4, right: 3, bottom: 4, left: 3 },
          },
          columnStyles,
          margin: { left: 20, right: 20 },
        });

        currentY = doc.lastAutoTable.finalY;

        if (i < filteredComplaints.length - 1) {
          currentY += 15;
          doc.setDrawColor(200, 200, 200);
          doc.line(20, currentY, pageWidth - 20, currentY);
          currentY += 15;
        }
      }
    }

    // Footer
    const pageHeight = doc.internal.pageSize.height;
    if ((doc.lastAutoTable?.finalY || currentY) + 180 > pageHeight) {
      doc.addPage();
    }
    const footerY = pageHeight - 180;
    doc.setFontSize(10);
    doc.setFont(fontName, "normal");
    doc.text("Letter No. :", 20, footerY + 100);
    doc.text("Date :", 20, footerY + 120);
    doc.text("Copy :", 20, footerY + 140);
    doc.text("XXXX", 550, footerY + 100);
    doc.text("XXXXXXXXX", 550, footerY + 120);
    doc.text("XXXXXX", 550, footerY + 140);

    const now = new Date();
    const istDate = now.toISOString().split("T")[0].replace(/-/g, "");
    const h = now.getHours().toString().padStart(2, "0");
    const m = now.getMinutes().toString().padStart(2, "0");
    const s = now.getSeconds().toString().padStart(2, "0");
    doc.save(`grievance_report_${istDate}_${h}${m}${s}.pdf`);
  } catch (error) {
    console.error("Error generating PDF:", error);
    toast.error("Error generating PDF. Please try again.");
  }
};
const stripHtml = (html) =>
  html ? html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim() : "";

const downloadExcel = async () => {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Grievance Data");

    // Updated headers — removed Bank Name, Branch Name, Support Team, Assigned To, Sub Category
    const allHeaders = [
      "Ticket ID",
      "Region Name",
      "Ticket Created Date & Time",
      "Reported By",
      "Resolved By",
      "Category",
      "Escalation Level",
      "Priority",
      "Status",
      "Status Updated Date & Time",
      "Record Updated On",
      "Subject",
      "Description",
    ];

    const headerRow = worksheet.addRow(allHeaders);
    headerRow.font = { bold: true };

    for (let col = 1; col <= 13; col++) {
      const cell = headerRow.getCell(col);
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    }

    filteredComplaints.forEach((grievance) => {
      const oldGrievances =
        grievance.originalData?.oldGrievanceInformationEntity || [];
      const regionName =
        grievance.originalData?.regionName || grievance.bank || "N/A";

      const mainDataRow = worksheet.addRow([
        grievance.id || "N/A",
        regionName,
        grievance.date || "N/A",
        grievance.requesterBy || "N/A",
        grievance.resolvedBy || "Not Yet Resolved",
        grievance.issueTypeName || "N/A",
        grievance.userLevels || "N/A",
        grievance.criticality || "N/A",
        grievance.status || "N/A",
        grievance.lastStatusUpdated || "N/A",
        grievance.updated_on || "N/A",
        grievance.subject || "N/A",
        stripHtml(grievance.originalData?.description || grievance.details) || "N/A",
      ]);

      for (let col = 1; col <= 13; col++) {
        const cell = mainDataRow.getCell(col);
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      }

      if (oldGrievances.length > 0) {
        oldGrievances.forEach((oldGrievance) => {
          const statusUpdates = oldGrievance.grievanceStatusMapEntities || [];
          let lastStatusUpdated = "N/A";
          if (statusUpdates.length > 0) {
            const sorted = [...statusUpdates].sort(
              (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
            );
            lastStatusUpdated = formatDateTime(sorted[0].createdOn);
          }
          const oldRegionName =
            oldGrievance.regionName || oldGrievance.bankNameShort || "N/A";

          const prevDataRow = worksheet.addRow([
            oldGrievance.grievanceSeqId || "N/A",
            oldRegionName,
            formatDateTime(
              oldGrievance.ticketDateAndTime || oldGrievance.created_on
            ) || "N/A",
            oldGrievance.requesterBy || "N/A",
            oldGrievance.resolvedBy || "Not Yet Resolved",
            oldGrievance.issueTypeName || "N/A",
            oldGrievance.userLevel || "N/A",
            oldGrievance.priority || "N/A",
            getStatusFromId(oldGrievance.status) || "Open",
            lastStatusUpdated || "N/A",
            formatDateTime(oldGrievance.updated_on) || "N/A",
            oldGrievance.subject || "N/A",
            stripHtml(oldGrievance.description) || "N/A",
          ]);

          for (let col = 1; col <= 13; col++) {
            const cell = prevDataRow.getCell(col);
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          }
        });
      }
    });

    // Column widths
    worksheet.getColumn("A").width = 20; // Ticket ID
    worksheet.getColumn("B").width = 25; // Region Name
    worksheet.getColumn("C").width = 30; // Ticket Created Date
    worksheet.getColumn("D").width = 22; // Reported By
    worksheet.getColumn("E").width = 22; // Resolved By
    worksheet.getColumn("F").width = 25; // Category
    worksheet.getColumn("G").width = 15; // Escalation Level
    worksheet.getColumn("H").width = 12; // Priority
    worksheet.getColumn("I").width = 18; // Resolved Ageing
    worksheet.getColumn("J").width = 18; // Closed Ageing
    worksheet.getColumn("K").width = 15; // Status
    worksheet.getColumn("L").width = 30; // Status Updated
    worksheet.getColumn("M").width = 30; // Record Updated On
    worksheet.getColumn("N").width = 30; // Subject
    worksheet.getColumn("O").width = 45; // Description

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const now = new Date();
    const istDate = now.toISOString().split("T")[0].replace(/-/g, "");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const seconds = now.getSeconds().toString().padStart(2, "0");
    a.download = `grievance_report_${istDate}_${hours}${minutes}${seconds}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error generating Excel:", error);
    toast.error("Error generating Excel file. Please try again.");
  }
};
 

  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      console.log("User Profile Response:", response);
      if (response && Array.isArray(response) && response.length > 0) {
        setUserId(response[0].id);
        setCurrentUser(response[0]); // Store the current user data
        // Add this line to set the user role
        setUserRole(response[0].role_name);
        setIsAdmin(response[0].is_admin);
        setIsDepartmentAdmin(response[0].is_dep_admin === true);
        setIsSupportAdmin(response[0].is_dep_admin === true);
        console.log("User Level from profile:", response[0].user_level);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };
  const getUsersLists = async () => {
    try {
      const profileResponse = await getData(getThemeURL);
      const stateId = profileResponse && profileResponse[0]?.state_id;
      const url = getUsersByLevels.replace("STATE_ID", stateId || "");
      
      const reportedByResponse = await postDataWithBody(url, ["L1"], {});
      if(Array.isArray(reportedByResponse)) {
        setReportedByUsers(reportedByResponse);
      }
      
      const resolvedByResponse = await postDataWithBody(url, ["L2", "L3"], {});
      if(Array.isArray(resolvedByResponse)) {
        setResolvedByUsers(resolvedByResponse);
      }
    } catch (error) {
      console.error("Error fetching users by levels:", error);
    }
  };


const getAllDepartments = async () => {
  try {
    const response = await getData(departmentslist);
    console.log("Departments All:", response);
    setAllDepartments(response); // Store in state
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};

  const getCurrentDateTime = () => {
    const now = new Date();
    return formatDateTimeForAPI(now);
  };

  //to fetch all grievance data
  useEffect(
    () => {
      if (userId) {
        getAllGrievanceData();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userId]
  );

  // Auto-select category when only one option is available
useEffect(() => {
  let filteredCategories = issueTypes;
  
  if (shouldApplyDepartmentFilter()) {
    filteredCategories = issueTypes.filter(issue => 
      issue.department_id === userDepartmentId
    );
  }
  
  // If only one category is available, auto-select it
  if (filteredCategories.length === 1) {
    setSelectedCategory(filteredCategories[0].value);
  } else if (filteredCategories.length === 0) {
    setSelectedCategory("All Categories");
  }
}, [issueTypes, userDepartmentId, shouldApplyDepartmentFilter]);

// Auto-select department when only one option is available
useEffect(() => {
  let filteredDepts = allDepartments.filter(dept => !dept.is_deleted && dept.is_helpdesk === true);
  
  if (shouldApplyDepartmentFilter()) {
    filteredDepts = filteredDepts.filter(dept => dept.id === userDepartmentId);
  }
  
  // If only one department is available, auto-select it
  if (filteredDepts.length === 1) {
    setSelectedDepartment(filteredDepts[0].id.toString());
  } else if (filteredDepts.length === 0) {
    setSelectedDepartment("");
  }
}, [allDepartments, userDepartmentId, shouldApplyDepartmentFilter]);

  const getAllGrievanceData = async () => {
    setLoader(true); // Start loading
    try {
      // Get user profile to determine role and construct payload
      const userProfile = await getData(getThemeURL);

      if (
        !userProfile ||
        !Array.isArray(userProfile) ||
        userProfile.length === 0
      ) {
        toast.error("Failed to fetch user profile", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setLoader(false); // Stop loading on error
        return;
      }

      const user = userProfile[0];
const payload = createGrievancePayload(user, {
  reportedBy,
  resolvedBy,
  statusFilter,
  selectedCategory,
  priorityLevel,
  selectedDepartment,
  fromDate,
  toDate,
  selectedBankId,
  selectedBranch,
});

      // Fetch grievance data with role-based payload
      const grievanceData = await postDataWithBody(
        fetchGrievanceData,
        payload,
        {}
      );

      if (Array.isArray(grievanceData)) {
        // Sort by creation date (newest first)
        // const sortedList = grievanceData.sort((a, b) => {
        //   return new Date(b.created_on) - new Date(a.created_on);
        // });

        // ADD THIS LINE - Process the sortedList to transform grievanceStatusMapEntities
const processedSortedList = processSortedListData(grievanceData);

        // Transform the data to match table structure
        // Transform the data to match table structure
const transformedData = processedSortedList.map((item) => {
  const statusUpdates = item.grievanceStatusMapEntities || [];
  let lastStatusUpdated = "N/A";
  
  if (statusUpdates.length > 0) {
    const sortedStatusUpdates = [...statusUpdates].sort((a, b) => 
      new Date(b.createdOn) - new Date(a.createdOn)
    );
    lastStatusUpdated = formatDateTime(sortedStatusUpdates[0].createdOn);
  }

  return {
    id: item.grievanceSeqId,
    bank: item.bankNameShort,
    branch: item.branchNameShort,
    regionName: item.regionName || item.bankNameShort || "N/A",  // ← ADD THIS
    bankCode: item.bankCode,
    branchCode: item.branchCode,
    channel: "Web",
    type: item.issueTypeName,
    subject: item.subject,
    details: item.description
      ? item.description.replace(/<^>]*>/g, "")
      : "",
    date: formatDateTime(item.ticketDateAndTime || item.created_on),
    criticality: item.priority,
    status: getStatusFromId(item.status),
    handler: item.assignedTeamName,
    issueTypeName: item.issueTypeName,
    userLevels: item.userLevel,
    customerName: item.customerName,
    email: item.email,
    phoneNumber: item.phoneNumber,
    issueTypeSubCatName: item.issueTypeSubCatName,
    requesterBy: item.requesterBy,
    resolutionMethod: item.resoultionName,
    mediaList: item.mediaList || [],
    originalData: item,
    isDisable: item.is_disable,
    lastStatusUpdated: lastStatusUpdated,
    updated_on: formatDateTime(item.updated_on || item.lastUpdatedOn),
    assignToUserName: item.assignToUserName || "Unassigned",
    slaPaused: item.slaPaused,
    slaPausedAt: item.slaPausedAt || "N/A",
    slaRemainingMinutes: item.slaRemainingMinutes || "N/A",
    resolvedBy: item.resolvedBy || "Not Yet Resolved",
  };
});

        setComplaints(transformedData);
        setFilteredComplaints(transformedData);
        setRowCount(transformedData.length);
        setTotalPages(Math.ceil(transformedData.length / itemsPerPage));
        setTotalComplaints(transformedData.length);

        // pending complaints (Open)
        const pending = transformedData.filter(
          (item) => item.status === "Open"
        ).length;
        setPendingComplaints(pending);

        setIsLoaded(true);
      }
    } catch (error) {
      console.error("Error fetching grievance data:", error);
      toast.error("Failed to load grievance data");
      setIsLoaded(true);
    } finally {
      setLoader(false); // Stop loading whether success or error
    }
  };

const createGrievancePayload = (userProfile, filters = {}) => {
  const {
    role_name,
    id: userId,
    is_admin,
    user_level,
    userLevel,
    region_id,
  } = userProfile;

  // Use whichever is available (API returns camelCase 'userLevel')
  const resolvedUserLevel = user_level || userLevel || null;

  const {
    reportedBy,
    resolvedBy,
    statusFilter,
    selectedCategory,
    priorityLevel,
    selectedDepartment,
    fromDate,
    toDate,
    selectedBankId,
    selectedBranch,
  } = filters;

  // Build base payload
  let basePayload = {};

  if (role_name === "SUPER ADMIN") {
    basePayload = {
      admin_role: "SA",
      region_id: null,
      userId: userId || null,
      userLevel: resolvedUserLevel,
    };
  } else if (is_admin === true) {
    basePayload = {
      admin_role: "HO",
      region_id: null,
      userId: userId || null,
      userLevel: resolvedUserLevel,
    };
  } else {
    basePayload = {
      admin_role: "USER",
      region_id: region_id || null,
      userId: userId || null,
      userLevel: resolvedUserLevel,
    };
  }

  // Conditionally add filter fields only if they have a value
  if (reportedBy && reportedBy !== "") {
    basePayload.reported_by = parseInt(reportedBy);
  }

  if (resolvedBy && resolvedBy !== "") {
    basePayload.resolved_by = parseInt(resolvedBy);
  }

  if (statusFilter && statusFilter !== "Status - All") {
    const statusIdMap = {
      "Open": 837,
      "In Progress": 838,
      "Hold": 839,
      "Resolved": 840,
      "Closed": 841,
      "Rejected": 842,
      "Issue Pending at User Level": 850,
      "Issue Pending at External Vendor": 851,
    };
    const statusId = statusIdMap[statusFilter];
    if (statusId) {
      basePayload.status = statusId;
    }
  }

  if (selectedCategory && selectedCategory !== "All Categories") {
    const matchedIssue = issueTypes.find(i => i.value === selectedCategory);
    if (matchedIssue) {
      basePayload.categories = matchedIssue.id;
    }
  }

  if (priorityLevel && priorityLevel !== "") {
    basePayload.escalation_level = priorityLevel;
  }

  if (selectedDepartment && selectedDepartment !== "") {
    basePayload.support_team = parseInt(selectedDepartment);
  }

  if (fromDate && fromDate !== "") {
    basePayload.from_date = fromDate;
  }

  if (toDate && toDate !== "") {
    basePayload.to_date = toDate;
  }

  if (selectedBankId && selectedBankId !== "" && is_admin !== true) {
    basePayload.bank = parseInt(selectedBankId);
  }

  if (selectedBranch && selectedBranch !== "") {
    basePayload.branch = parseInt(selectedBranch);
  }

  console.log("Grievance payload:", basePayload);
  return basePayload;
};
  //To load data in table based on the filtered items
  useEffect(() => {
    if (isLoaded) {
      setTotalPages(Math.ceil(filteredComplaints.length / itemsPerPage) || 1);
    }
  }, [itemsPerPage, filteredComplaints, isLoaded]);

  console.log("totalPages", totalPages);
  console.log("setItemsPerPage", setItemsPerPage);


// WITH:
useEffect(() => {
  if (isLoaded && userId) {
    getAllGrievanceData();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [
  statusFilter,
  selectedBankId,
  selectedBranch,
  selectedCategory,
  reportedBy,
  resolvedBy,
  priorityLevel,
  selectedDepartment,
  fromDate,
  toDate,
]);

// Keep a SEPARATE useEffect for search (client-side only):
useEffect(() => {
  if (isLoaded) {
    if (searchQuery.trim() === "") {
      setFilteredComplaints(complaints);
      setRowCount(complaints.length);
      setTotalPages(Math.ceil(complaints.length / itemsPerPage) || 1);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = complaints.filter((item) => {
        const mainMatches =
          (item.id && item.id.toString().toLowerCase().includes(query)) ||
          (item.type && item.type.toLowerCase().includes(query)) ||
          (item.subject && item.subject.toLowerCase().includes(query)) ||
          (item.details && item.details.toLowerCase().includes(query)) ||
          (item.branch && item.branch.toLowerCase().includes(query)) ||
          (item.bank && item.bank.toLowerCase().includes(query)) ||
          (item.customerName && item.customerName.toLowerCase().includes(query));

        if (mainMatches) return true;

        const oldGrievances = item.originalData?.oldGrievanceInformationEntity || [];
        return oldGrievances.some(og =>
          (og.grievanceSeqId && og.grievanceSeqId.toString().toLowerCase().includes(query)) ||
          (og.bankName && og.bankName.toLowerCase().includes(query)) ||
          (og.branchName && og.branchName.toLowerCase().includes(query)) ||
          (og.issueTypeName && og.issueTypeName.toLowerCase().includes(query)) ||
          (og.subject && og.subject.toLowerCase().includes(query)) ||
          (og.requesterBy && og.requesterBy.toLowerCase().includes(query)) ||
          (og.resolvedBy && og.resolvedBy.toLowerCase().includes(query)) ||
          (og.assignToUserName && og.assignToUserName.toLowerCase().includes(query))
        );
      });
      setFilteredComplaints(filtered);
      setRowCount(filtered.length);
      setTotalPages(Math.ceil(filtered.length / itemsPerPage) || 1);
    }
    setCurrentPage(1);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [searchQuery, complaints]);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchPriorities = async () => {
      try {
        const response = await getData(getAllSLA);
        if (response && Array.isArray(response)) {
          // Extract unique priorities from the response
          const priorityList = response;
          // .filter(item => item.activeStatus && !item.is_deleted)
          // .map(item => item.priority);
          setPriorities(priorityList);
        }
      } catch (error) {
        console.error("Error fetching priorities:", error);
      }
    };

    fetchPriorities();
  }, []);

  const formatDateTimeForAPI = (date) => {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");

    return `${dd}-${mm}-${yyyy} ${formattedHours}:${minutes} ${ampm}`;
  };

   // Helper function to extract bankId from grievance data
const getBankIdFromGrievance = (grievance) => {
  if (!grievance) return null;
  
  // Try different possible locations for bankId
  const bankCode = grievance.originalData?.bankCode || 
                 grievance.originalData?.bank?.bankCode ||
                 grievance.bankCode ||
                 grievance.bank?.bankCode;
  
  console.log("Extracted bankId from grievance:", bankCode);
  return bankCode;
};

// Update the fetchHolidays call
useEffect(() => {
  if (selectedGrievance) {
    const bankCode = getBankIdFromGrievance(selectedGrievance);
    if (bankCode) {
      fetchHolidays(bankCode);
    } else {
      console.log("No bankId found for selected grievance");
      setHolidays([]);
    }
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedGrievance]);
const calculateSLADate = (priority, currentDate) => {
  if (!priority || !priorities || priorities.length === 0) {
    console.log("No priority or SLA data found, using default 2 hours");
    return new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
  }

  const slaConfig = priorities.find(
    (sla) => sla.priority && sla.priority.toLowerCase() === priority.toLowerCase()
  );

  if (!slaConfig) {
    console.log("No SLA config found for priority:", priority, "using default 2 hours");
    return new Date(currentDate.getTime() + 2 * 60 * 60 * 1000);
  }

  const { maxResTimeValue, maxResTimeType } = slaConfig;
  let targetDate = new Date(currentDate);
  
  console.log("SLA Calculation - Priority:", priority, "MaxTime:", maxResTimeValue, maxResTimeType);
  console.log("Current date:", currentDate);
  console.log("Holidays available:", holidays.length);
  console.log("Selected grievance bankId:", selectedGrievance?.originalData?.bankCode);
  console.log("Is loading holidays:", isLoadingHolidays);

  // If holidays are still loading, use standard calculation for now
  if (isLoadingHolidays) {
    console.log("Holidays still loading, using standard calculation temporarily");
    // Use standard calculation but you might want to delay this
  }

  // Only use holiday-aware functions if holidays are available and loaded
  if (holidays.length > 0 && !isLoadingHolidays) {
    console.log("Using holiday-aware SLA calculation with", holidays.length, "holidays");
    switch (maxResTimeType?.toLowerCase()) {
      case "minutes":
        targetDate = addMinutesExcludingSundaysAndHolidays(currentDate, maxResTimeValue);
        break;
      case "hours":
        targetDate = addHoursExcludingSundaysAndHolidays(currentDate, maxResTimeValue);
        break;
      case "days":
        targetDate = addDaysExcludingSundaysAndHolidays(currentDate, maxResTimeValue);
        break;
      default:
        console.log("Unknown time type, using default calculation");
        break;
    }
  } else {
    console.log("Using standard SLA calculation (no holidays available)");
    // Fallback to Sunday-only exclusion
    switch (maxResTimeType?.toLowerCase()) {
      case "minutes":
        targetDate.setMinutes(targetDate.getMinutes() + maxResTimeValue);
        break;
      case "hours":
        targetDate.setHours(targetDate.getHours() + maxResTimeValue);
        if (targetDate.getDay() === 0) {
          targetDate.setDate(targetDate.getDate() + 1);
        }
        break;
      case "days":
        targetDate = addDaysExcludingSundays(currentDate, maxResTimeValue);
        break;
      default:
        console.log("Unknown time type in fallback");
        break;
    }
  }

  console.log("Final SLA date:", targetDate);
  return targetDate;
};

// Recalculate SLA when holidays are loaded
useEffect(() => {
  if (holidays.length > 0 && selectedGrievance && selectedAction === "reopen") {
    console.log("Holidays loaded, SLA should be recalculated");
    // You might want to trigger a recalculation here if needed
  }
}, [holidays, selectedGrievance, selectedAction]);

  // Handle Action Confirmation
  const handleActionConfirmation = async () => {
    if (!selectedGrievance || !selectedAction) return;

    try {
      setIsAccepting(true);
      setLoader(true); // Show loader during action processing


      if (selectedAction === "accept") {
        // Get user profile to determine user level
        const userProfile = await getData(getThemeURL);
        const currentUser = userProfile && userProfile[0];
        const userLevel = currentUser?.user_level;

        // Create FormData payload for acceptance
        const formData = new FormData();

        // Base grievance data
        const grievanceData = {
          id: selectedGrievance.originalData.id,
          updated_by: userId,
        };

        // Add level-specific fields based on user level
        if (userLevel === "L3") {
          grievanceData.isAcceptToL3 = true;
          grievanceData.acceptedByL3 = userId;
        } else if (userLevel === "L2") {
          grievanceData.isAcceptToL2 = true;
          grievanceData.acceptedByL2 = userId;
        } else {
          grievanceData.isAccept = true;
          grievanceData.acceptedBy = userId;
        }

        formData.append("grievance", JSON.stringify(grievanceData));

        // Call the acceptAfterEsclation API
        // eslint-disable-next-line no-unused-vars
        const response = await postDataWithBody(
          acceptAfterEsclation,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        toast.success(
          `Grievance ${selectedGrievance.id} accepted successfully`,
          {
            position: "top-center",
            autoClose: 3000,
          }
        );
      } else if (selectedAction === "reopen") {
        // Handle reopen action with FormData
        const formData = new FormData();

        // Get current date and time in the required format (dd-mm-yyyy hh:mm AM/PM)
        const now = new Date();
        const reopenedDate = formatDateTimeForAPI(now);

        // Calculate resolution SLA date based on priority
        const priority =
          selectedGrievance.criticality ||
          selectedGrievance.originalData.priority;
        const resSLADate = calculateSLADate(priority, now);
        const resSLADateString = formatDateTimeForAPI(resSLADate);

        const reopenedToValue = reopenedTo
          ? parseInt(reopenedTo)
          : selectedGrievance.originalData.createdBy;

          const userLevelFromGrievance = 
    selectedGrievance.userLevels || // From transformed data
    selectedGrievance.originalData?.userLevel || // From original data
    selectedGrievance.originalData?.user_level || // Alternative field name
    "L1"; // Fallback default

  console.log("Reopening with userLevel:", userLevelFromGrievance);
  

        // Construct the grievance object as per API requirements
        const grievanceData = {
          id: selectedGrievance.originalData.id,
          reOpenedDateAndTimeString: reopenedDate,
          resSLADateAndTimeString: resSLADateString,
          reOpenedTo: reopenedToValue,
          reOpenedRemarks: reopenRemarks,
          userLevel: userLevelFromGrievance,
        };

        // Append the grievance data as JSON string
        formData.append("grievance", JSON.stringify(grievanceData));

        if (selectedFiles.length > 0) {
          selectedFiles.forEach((fileObj, index) => {
            formData.append("files", fileObj.file);
          });
        } else {
          // Append null or empty file if no files are selected
          // Some APIs might require at least one file field, so we can append an empty file
          formData.append("files", new Blob(), "empty.txt");
          // Or simply don't append anything if the API accepts no files
        }
        // Call the reopenAfterClosed API
        // eslint-disable-next-line no-unused-vars
        const response = await postDataWithBody(reopenAfterClosed, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        toast.success(
          `Grievance ${selectedGrievance.id} reopened successfully with ${selectedFiles.length} file(s)`,
          {
            position: "top-center",
            autoClose: 3000,
          }
        );
      }

      // Close confirmation modal and reset states
      closeConfirmationModal();
      setReopenRemarks("");
      setSelectedFiles([]);
      setFileErrors([]);
      setReopenedTo("");

      // Refresh the grievance data to reflect the changes
      getAllGrievanceData();
    } catch (error) {
      console.error(`Error ${selectedAction}ing grievance:`, error);
      toast.error(`Failed to ${selectedAction} grievance. Please try again.`, {
        position: "top-center",
        autoClose: 3000,
      });
    } finally {
      setIsAccepting(false);
      setLoader(false); // Hide loader after action completes
    }
  };

  //color and background for statuses
const renderStatusBadge = (status) => {
  if (!status) return "NA";

  let backgroundColor = "";
  let dotColor = "";
  let textColor = "";

  switch (status) {
    case "Open":
      backgroundColor = "#FDE2E4";
      dotColor = "#D90429";
      textColor = "#D90429";
      break;
    case "In Progress":
    case "In progress someone":
      backgroundColor = "#FFF1E6";
      dotColor = "#FF7F11";
      textColor = "#FF7F11";
      break;
    case "Hold":
      backgroundColor = "#FFF8E1";
      dotColor = "#FFC107";
      textColor = "#FFC107";
      break;
    case "Resolved":
    case "Resolved someone":
      backgroundColor = "#E2F0CB";
      dotColor = "#228B22";
      textColor = "#228B22";
      break;
    case "Closed":
      backgroundColor = "#E0E8F9";
      dotColor = "#304FFE";
      textColor = "#304FFE";
      break;
    case "Rejected":
      backgroundColor = "#FBE3E8";
      dotColor = "#B00020";
      textColor = "#B00020";
      break;
    case "Escalated to L2":
      backgroundColor = "#E3F2FD";
      dotColor = "#4CA2C4";
      textColor = "#4CA2C4";
      break;
    case "Accept":
      backgroundColor = "#E8F5E9";
      dotColor = "#2E7D32";
      textColor = "#2E7D32";
      break;
    // NEW STATUSES - Add styling for the two new statuses
    case "Issue Pending at User Level": // 850
      backgroundColor = "#FFF0F7";
      dotColor = "#C2185B";
      textColor = "#C2185B";
      break;
    case "Issue Pending at External Vendor": // 851
      backgroundColor = "#F3E5F5";
      dotColor = "#7B1FA2";
      textColor = "#7B1FA2";
      break;
    default:
      return "NA";
  }

  return (
    <div className="status-badge-container" style={{ position: "relative" }}>
      <div
        className="status-badge"
        style={{
          backgroundColor,
          color: textColor,
          borderRadius: "5px",
          padding: "4px 10px 4px 20px",
          display: "inline-block",
          width: "120px",
          // height: "28px",
          lineHeight: "20px",
          fontFamily: "Poppins",
          fontWeight: 500,
          fontSize: "12px",
          position: "relative",
          textAlign: "left",
        }}
      >
        <div
          className="status-dot"
          style={{
            backgroundColor: dotColor,
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            position: "absolute",
            left: "8px",
            top: "10px",
          }}
        ></div>
        {status}
      </div>
    </div>
  );
};

  //color and background for criticality
  const renderCriticality = (criticality) => {
    if (!criticality) return "NA";

    let textColor = "";

    switch (criticality.toUpperCase()) {
      case "CRITICAL":
        textColor = "#DC3545";
        break;
      case "HIGH":
        textColor = "#FD7E14";
        break;
      case "LOW":
        textColor = "#28A745";
        break;
      case "NORMAL":
        textColor = "#FFC107";
        break;
      default:
        textColor = "#808080";
    }

    return (
      <span
        style={{
          color: textColor,
          fontWeight: "bold",
          fontFamily: "Poppins",
          fontSize: "12px",
        }}
      >
        {criticality}
      </span>
    );
  };

  // Actions Icons Component with Lucide Icons
  const ActionsIcons = ({ grievance, userLevel }) => {
    // Check if actions should be shown (same logic as before)
    const grievanceData = grievance.originalData;

const shouldShowAccept =
  grievanceData.escalated &&
  userLevel &&
  grievanceData?.userLevel &&
  userLevel === grievanceData.userLevel &&
  userLevel !== "L2" &&
  !grievanceData.acceptedByL3;


    const shouldShowReopen =
      userLevel &&
      grievance.originalData?.userLevel &&
      userLevel === grievance.originalData.userLevel &&
      grievance.status === "Closed";

    if (!shouldShowAccept && !shouldShowReopen) {
      return null;
    }

    return (
      <div
        className="actions-icons-container"
        style={{
          display: "flex",
          gap: "8px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Accept Icon */}
        {shouldShowAccept && (
          <div
            className="action-icon accept-icon"
            onClick={() => openConfirmationModal(grievance, "accept")}
            style={{
              cursor: "pointer",
              padding: "6px",
              borderRadius: "4px",
              backgroundColor: "#E8F5E8",
              border: "1px solid #28A745",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#28A745";
              e.currentTarget.querySelector("svg").style.stroke = "white";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#E8F5E8";
              e.currentTarget.querySelector("svg").style.stroke = "#28A745";
              e.currentTarget.style.transform = "scale(1)";
            }}
            title="Accept Grievance"
          >
            <CircleCheckBig size={16} color="#28A745" />
          </div>
        )}

        {/* Reopen Icon */}
        {/* {shouldShowReopen && (
          <div
            className="action-icon reopen-icon"
            onClick={() => openConfirmationModal(grievance, "reopen")}
            style={{
              cursor: "pointer",
              padding: "6px",
              borderRadius: "4px",
              backgroundColor: "#E3F2FD",
              border: "1px solid #2196F3",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#2196F3";
              e.currentTarget.querySelector("svg").style.stroke = "white";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#E3F2FD";
              e.currentTarget.querySelector("svg").style.stroke = "#2196F3";
              e.currentTarget.style.transform = "scale(1)";
            }}
            title="Reopen Grievance"
          >
            <RefreshCcw size={16} color="#2196F3" />
          </div>
        )} */}
      </div>
    );
  };

  // ADD new function to fetch bulk assign users list (add after fetchUserProfile)
const fetchBulkAssignUsers = async () => {
  try {
    const response = await getData(userListForSupportAdmin);
    console.log("Bulk Assign Users Response:", response);
    if (response && Array.isArray(response)) {
      const activeUsers = response.filter(user => user.status === "true" || user.status === true);
      setBulkAssignUsersList(activeUsers);
    }
  } catch (error) {
    console.error("Error fetching bulk assign users:", error);
    toast.error("Failed to load users list", {
      position: "top-center",
      autoClose: 2000,
    });
  }
};

// ADD useEffect to fetch bulk assign users when department admin status changes
useEffect(() => {
  if (isDepartmentAdmin) {
    fetchBulkAssignUsers();
  }
}, [isDepartmentAdmin]);

// ADD checkbox handler functions
const handleCheckboxChange = (grievanceId) => {
  setSelectedGrievances(prev => {
    if (prev.includes(grievanceId)) {
      return prev.filter(id => id !== grievanceId);
    } else {
      if (prev.length >= 10) {
        toast.warning("Maximum 10 tickets can be selected at once", {
          position: "top-center",
          autoClose: 2000,
        });
        return prev;
      }
      return [...prev, grievanceId];
    }
  });
};

const handleSelectAll = (isChecked) => {
  if (isChecked) {
    const eligibleGrievances = filteredComplaints
      .filter(g => (g.status === "Open" || 
         g.status === "In Progress" || 
         g.status === "Issue Pending at External Vendor") && g.assignToUserName === "Unassigned" && g.userLevels === "L2")
      .map(g => g.originalData.id)
      .slice(0, 10);
    setSelectedGrievances(eligibleGrievances);
    if (filteredComplaints.filter(g => (g.status === "Open" || 
       g.status === "In Progress" || 
       g.status === "Issue Pending at External Vendor") && g.assignToUserName === "Unassigned" && g.userLevels === "L2").length > 10) {
      toast.warning("Only first 10 eligible tickets selected (maximum limit)", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  } else {
    setSelectedGrievances([]);
  }
};

// ADD function to open bulk assign modal
const openBulkAssignModal = () => {
  setSelectedBulkAssignUser("");
  setShowBulkAssignModal(true);
};

// ADD function to close bulk assign modal
const closeBulkAssignModal = () => {
  setShowBulkAssignModal(false);
  setSelectedBulkAssignUser("");
};

// ADD function to handle bulk assignment submission
const handleBulkAssignSubmit = async () => {
  if (!selectedBulkAssignUser) {
    toast.error("Please select a user", {
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  try {
    setIsBulkAssigning(true);
    setLoader(true);

    const formData = new FormData();
    
    // Create payload with separate values
    formData.append('grievanceIds', selectedGrievances.join(','));
    formData.append('l2UserId', selectedBulkAssignUser);
    formData.append('adminUserId', userId);

    console.log('Bulk Assignment payload:', {
      grievanceIds: selectedGrievances.join(','),
      l2UserId: selectedBulkAssignUser,
      adminUserId: userId
    });

    const response = await postDataWithBody(
      bulkAssign,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log('Bulk Assignment response:', response);

    toast.success(
      response.msg,
      {
        position: "top-center",
        autoClose: 3000,
      }
    );

    // Close modal and refresh
    closeBulkAssignModal();
    setSelectedGrievances([]);
    getAllGrievanceData();

  } catch (error) {
    console.error("Error in bulk assignment:", error);
    toast.error("Failed to assign tickets. Please try again.", {
      position: "top-center",
      autoClose: 3000,
    });
  } finally {
    setIsBulkAssigning(false);
    setLoader(false);
  }
};

// ADD helper function to get user display name
const getBulkAssignUserDisplayName = (user) => {
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  } else if (user.first_name) {
    return user.first_name;
  } else {
    return user.user_name || 'Unknown User';
  }
};


// ADD function to fetch Support Admin users list
const fetchSupportAdminUsers = async () => {
  try {
    const response = await getData(userListForSupportAdmin);
    console.log("Support Admin Users Response:", response);
    if (response && Array.isArray(response)) {
      const activeUsers = response.filter(user => user.status === "true" || user.status === true);
      setSupportAdminUsersList(activeUsers);
    }
  } catch (error) {
    console.error("Error fetching support admin users:", error);
    toast.error("Failed to load users list", {
      position: "top-center",
      autoClose: 2000,
    });
  }
};

// ADD useEffect to fetch support admin users when component mounts
useEffect(() => {
  if (isSupportAdmin) {
    fetchSupportAdminUsers();
  }
}, [isSupportAdmin]);

// ADD function to check if Support Admin assign button should be enabled
const isSupportAdminAssignEnabled = (grievance) => {
  const escalationLevel = grievance.userLevels;
  const status = grievance.status;
  const assignedByAdmin = grievance.originalData?.assignedByAdmin;
  const assignToUserName = grievance.assignToUserName || grievance.originalData?.assignToUserName;
  // Check if escalation level is L2
  if (escalationLevel !== "L2") {
    return false;
  }

  // ✅ ADD THIS: If Unassigned, button should be disabled
  if (!assignToUserName || assignToUserName === "Unassigned") {
    return false;
  }

  // Check conditions based on status
  if (status === "Open" && assignedByAdmin === true) {
    return true;
  }

  if (status === "In Progress") {
    return true;
  }

  if (status === "Issue Pending at External Vendor") {
    return true;
  }

  // NEW CONDITION: If status is Open and assigned to someone (not Unassigned)
  if (status === "Open" && assignToUserName && assignToUserName !== "Unassigned") {
    return true;
  }

  return false;
};

// ADD function to open Support Admin assign modal
const openSupportAdminAssignModal = (grievance) => {
  setSelectedGrievanceForSupportAdminAssign(grievance);
  setSelectedSupportAdminUser("");
  setSupportAdminAssignmentDescription("");
  setShowSupportAdminAssignModal(true);
};

// ADD function to close Support Admin assign modal
const closeSupportAdminAssignModal = () => {
  setShowSupportAdminAssignModal(false);
  setSelectedGrievanceForSupportAdminAssign(null);
  setSelectedSupportAdminUser("");
  setSupportAdminAssignmentDescription("");
};

// ADD function to handle Support Admin assignment submission
const handleSupportAdminAssignSubmit = async () => {
  if (!selectedSupportAdminUser) {
    toast.error("Please select a user", {
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  if (!supportAdminAssignmentDescription.trim()) {
    toast.error("Please provide assignment description", {
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  if (supportAdminAssignmentDescription.length >= 750) {
    toast.error("Description exceeds maximum length of 750 characters", {
      position: "top-center",
      autoClose: 2000,
    });
    return;
  }

  try {
    setIsSupportAdminAssigning(true);
    setLoader(true);

    const formData = new FormData();

    const oldL2UserId = selectedGrievanceForSupportAdminAssign.originalData.assignToUserId;

    // Create the assignment payload
    const assignmentData = {
      grievance_id: selectedGrievanceForSupportAdminAssign.originalData.id,
      reassigned_by_user: userId,
      new_l2_user_id: parseInt(selectedSupportAdminUser),
      old_l2_user_id: parseInt(oldL2UserId),
      reassignment_description: supportAdminAssignmentDescription.trim()
    };

    // Append as JSON string
    formData.append('grievance', JSON.stringify(assignmentData));

    console.log('Support Admin Assignment payload:', assignmentData);

    // Call the API
    const assignmentCall = await postDataWithBody(
      assignNewL2User,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log('Support Admin Assignment response:', assignmentCall);

    toast.success(
      `Ticket ${selectedGrievanceForSupportAdminAssign.id} assigned successfully`,
      {
        position: "top-center",
        autoClose: 3000,
      }
    );

    // Close modal and refresh data
    closeSupportAdminAssignModal();
    getAllGrievanceData();

  } catch (error) {
    console.error("Error assigning ticket:", error);
    toast.error("Failed to assign ticket. Please try again.", {
      position: "top-center",
      autoClose: 3000,
    });
  } finally {
    setIsSupportAdminAssigning(false);
    setLoader(false);
  }
};

// ADD helper function to get user display name
const getSupportAdminUserDisplayName = (user) => {
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  } else if (user.first_name) {
    return user.first_name;
  } else {
    return user.user_name || 'Unknown User';
  }
};
  //table data
  const columns = React.useMemo(
    () => [
      ...(isDepartmentAdmin ? [{
      Header: ({ data }) => {
        const eligibleCount = filteredComplaints.filter(
          g => (g.status === "Open" || 
        g.status === "In Progress" || 
        g.status === "Issue Pending at External Vendor") && g.assignToUserName === "Unassigned" && g.userLevels === "L2"
        ).length;
        const allSelected = eligibleCount > 0 && selectedGrievances.length === Math.min(eligibleCount, 10);
        
        return (
          <input
            type="checkbox"
            checked={allSelected}
            onChange={(e) => handleSelectAll(e.target.checked)}
            disabled={eligibleCount === 0}
            style={{ cursor: eligibleCount === 0 ? 'not-allowed' : 'pointer' }}
          />
        );
      },
      accessor: 'checkbox',
      disableSortBy: true,
      width: 50,
      Cell: ({ row }) => {
        const isEligible = (
                    row.original.status === "Open" || 
                    row.original.status === "In Progress" || 
                    row.original.status === "Issue Pending at External Vendor"
                  ) && 
                          row.original.assignToUserName === "Unassigned" &&
                          row.original.userLevels === "L2";
        const isChecked = selectedGrievances.includes(row.original.originalData.id);
        const isDisabled = !isEligible || (selectedGrievances.length >= 10 && !isChecked);
        
        return (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => handleCheckboxChange(row.original.originalData.id)}
            disabled={isDisabled}
            style={{ 
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              opacity: isDisabled ? 0.5 : 1
            }}
          />
        );
      },
    }] : []),
      {
        Header: t("Ticket ID"),
        accessor: "id",
        disableSortBy: true,
        Cell: ({ value }) => {
          return (
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              {value || "NA"}
            </span>
          );
        },
      },
     {
  Header: t("Region Name"),
  accessor: "regionName",
  minWidth: 120,
  width: 120,
  maxWidth: 120,
  disableSortBy: true,
  Cell: ({ row }) => {
    // ← CHANGE THIS: was row.original.bank, now use regionName
    const regionName = row.original.regionName || row.original.bank || "N/A";
    const branch = row.original.branch;

    if (!branch || branch === "NA") {
      return (
        <div style={{ minWidth: "120px", width: "120px" }}>
          <span
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
              fontWeight: 500,
              display: "block",
              lineHeight: "1.2"
            }}
            title={regionName}
          >
            {regionName}
          </span>
        </div>
      );
    }

    return (
      <div style={{ minWidth: "120px", width: "120px" }}>
        <span
          style={{
            fontFamily: "Poppins",
            fontSize: "12px",
            fontWeight: 500,
            display: "block",
            lineHeight: "1.2",
            marginBottom: "2px"
          }}
          title={regionName}
        >
          {regionName}
        </span>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <span style={{
            fontFamily: "Poppins",
            fontSize: "11px",
            fontWeight: 400,
            color: "#666",
            marginRight: "4px",
            lineHeight: "1.2"
          }}>•</span>
          <span style={{
            fontFamily: "Poppins",
            fontSize: "11px",
            fontWeight: 400,
            color: "#666",
            fontStyle: "italic",
            lineHeight: "1.2",
            display: "block"
          }}
          title={`Branch: ${branch}`}>
            {branch}
          </span>
        </div>
      </div>
    );
  },
},
 
      {
        Header: () => (
          <div>
            {t("Ticket Created")}<br />{t("Date & Time")}
          </div>
        ),
        accessor: "date",
        minWidth: 100,
        width: 100,
        maxWidth: 100,
        disableSortBy: true,
        Cell: ({ value }) => {
          if (!value || value === "NA") {
            return <div style={{ minWidth: "100px", width: "100px" }}>NA</div>;
          }
          const parts = value.split(" ");
          const datePart = parts[0] || "";
          const timePart = parts.slice(1).join(" ") || "";
          return (
            <div style={{ minWidth: "100px", width: "100px" }}>
              <span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, display: "block" }}>{datePart}</span>
              <span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, display: "block" }}>{timePart}</span>
            </div>
          );
        },
      },
      {
        Header: t("Reported By"),
        accessor: "requesterBy",
        minWidth: 80,
        width: 80,
        maxWidth: 100,
        disableSortBy: true,
        Cell: ({ value }) => {
          if (!value || value === "NA") {
            return (
              <div style={{ minWidth: "80px", width: "80px" }}>
                <span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500 }}>NA</span>
              </div>
            );
          }
          const nameParts = value.split(" ");
          return (
            <div style={{ minWidth: "80px", width: "80px" }}>
              {nameParts.map((part, index) => (
                <span key={index} style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, display: "block" }}>
                  {part}
                </span>
              ))}
            </div>
          );
        },
      },
//       {
//         Header: t("Support Team"),
//         accessor: "handler",
//         minWidth: 100,
//         width: 100,
//         maxWidth: 100,
//         disableSortBy: true,
//         Cell: ({ value }) => (
//           <div 
//           style={{ minWidth: "100px", width: "100px" }}
//           >
//           <span
//             // onClick={() =>
//             //   value && value !== "NA" && openModal("Support Team", value)
//             // }
//             style={{
//               fontFamily: "Poppins",
//               fontSize: "12px",
//               fontWeight: 500,
//               // maxWidth: "80px",
//               overflow: "hidden",
//               // textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//               display: "inline-block",
//               // cursor: value && value !== "NA" ? "pointer" : "default",
//             }}
//             // title="Click to view full assigned team"
//           >
//             {value || "NA"}
//           </span>
//           </div>
//         ),
//       },
//         {
//   Header: t("Assigned To"),
//   accessor: "assignToUserName",
//   minWidth: 130,
//   width: 130,
//   maxWidth: 130,
//   disableSortBy: true,
//   Cell: ({ value }) => {
//   if (!value || value === "Unassigned") {
//     return (
//       <div style={{ minWidth: "130px", width: "130px" }}>
//         <span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500 }}>Unassigned</span>
//       </div>
//     );
//   }

//   // Check if value contains parenthetical part like "(Assigned by: Admin)"
//   const parenMatch = value.match(/^(.*?)\s*(\(.*\))$/);
  
//   if (parenMatch) {
//     const nameParts = parenMatch[1].trim().split(" ");
//     const parenPart = parenMatch[2];
//     return (
//       <div style={{ minWidth: "130px", width: "130px" }}>
//         {nameParts.map((part, index) => (
//           <span key={index} style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, display: "block" }}>
//             {part}
//           </span>
//         ))}
        
//           {parenPart}
        
//       </div>
//     );
//   }

//   // No parenthetical - just split name normally
//   const nameParts = value.split(" ");
//   return (
//     <div style={{ minWidth: "130px", width: "130px" }}>
//       {nameParts.map((part, index) => (
//         <span key={index} style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, display: "block" }}>
//           {part}
//         </span>
//       ))}
//     </div>
//   );
// },
// },
{
  Header: t("Resolved By"),
  accessor: "resolvedBy",
  minWidth: 120,
  width: 120,
  maxWidth: 200,
  disableSortBy: true,
  Cell: ({ value }) => (
    <div style={{ minWidth: "120px", width: "120px" }}>
    <span
      style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500 }}
    >
      {value || "Not Yet Resolved"}
    </span>
    </div>
  ),
},
      
       {
        Header: t("Category"),
        accessor: "issueTypeName",
        // minWidth: 150,
        width: 150,
        // maxWidth: 150,
        disableSortBy: true,
        Cell: ({ row }) => {
          const issueTypeName = row.original.issueTypeName || "N/A";
          const issueTypeSubCatName = row.original.issueTypeSubCatName;
 
          // Return early if no subcategory
          if (!issueTypeSubCatName || issueTypeSubCatName === "NA") {
            return (
              <div style={{ minWidth: "150px", width: "150px" }}>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    fontWeight: 500,
                    display: "block",
                    lineHeight: "1.2"
                  }}
                  title={issueTypeName}
                >
                  {issueTypeName}
                </span>
              </div>
            );
          }
 
          return (
            <div style={{ minWidth: "150px", width: "150px" }}>
              {/* Main category */}
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: 500,
                  display: "block",
                  lineHeight: "1.2",
                  marginBottom: "2px"
                }}
                title={issueTypeName}
              >
                {issueTypeName}
              </span>
 
              {/* Subcategory with bullet */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "11px",
                    fontWeight: 400,
                    color: "#666",
                    marginRight: "4px",
                    lineHeight: "1.2"
                  }}
                >
                  •
                </span>
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "11px",
                    fontWeight: 400,
                    color: "#666",
                    fontStyle: "italic",
                    lineHeight: "1.2",
                    display: "block"
                  }}
                  title={`Sub Category: ${issueTypeSubCatName}`}
                >
                  {issueTypeSubCatName}
                </span>
              </div>
            </div>
          );
        },
      },
 
         
         ...(userProfile?.[0]?.role_name !== "Citizen" ? [{
           Header: () => (
             <div>
               {t("Esc.")}<br />{t("Level")}
             </div>
           ),
        accessor: "userLevels",
        minWidth: 40,
        width: 40,
        maxWidth: 40,
        disableSortBy: true,
        Cell: ({ value }) => (
          <div style={{ minWidth: "40px", width: "40px" }}>
          <span
            style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500,}}
          >
            {value || "NA"}
          </span>
          </div>
        ),
      }] : []),
      {
        Header: t("Priority"),
        accessor: "criticality",
        disableSortBy: true,
        Cell: ({ value }) => renderCriticality(value),
      },
     
      {
        Header: t("Status"),
        accessor: "status",
        disableSortBy: false,
        Cell: ({ value }) => renderStatusBadge(value || "Open"),
      },
      {
        Header: () => (
             <div>
               {t("Status Updated")}<br />{t("Date & Time")}
             </div>
           ),
        accessor: "lastStatusUpdated",
        minWidth: 100,
        width: 100,
        maxWidth: 100,
        disableSortBy: true,
        Cell: ({ value }) => {
          if (!value || value === "N/A") {
            return <div style={{ minWidth: "100px", width: "100px" }}><span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500 }}>N/A</span></div>;
          }
          const parts = value.split(" ");
          const datePart = parts[0] || "";
          const timePart = parts.slice(1).join(" ") || "";
          return (
            <div style={{ minWidth: "100px", width: "100px" }}>
              <span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, display: "block" }}>{datePart}</span>
              <span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, display: "block" }}>{timePart}</span>
            </div>
          );
        },
      },
      {
        Header: () => (
             <div>
               {t("Record ")}<br />{t("Updated On")}
             </div>
           ),
        accessor: "updated_on",
        minWidth: 80,
        width: 80,
        maxWidth: 80,
        disableSortBy: true,
        Cell: ({ value }) => {
          if (!value || value === "N/A") {
            return <div style={{ minWidth: "80px", width: "80px" }}><span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500 }}>N/A</span></div>;
          }
          const parts = value.split(" ");
          const datePart = parts[0] || "";
          const timePart = parts.slice(1).join(" ") || "";
          return (
            <div style={{ minWidth: "80px", width: "80px" }}>
              <span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, display: "block" }}>{datePart}</span>
              <span style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: 500, display: "block" }}>{timePart}</span>
            </div>
          );
        },
      },
  {
      Header: t("Action"),
      disableSortBy: true,
      Cell: (props) => {
        const [isdelete, setIsdelete] = useState(false);
        const [userLevel, setUserLevel] = useState(null);
        const [isAdmin, setIsAdmin] = useState(false);
        // const [showPauseModal, setShowPauseModal] = useState(false); // State for pause modal
        // In your state declarations at the top, add these states:
const [showBreachModal, setShowBreachModal] = useState(false);
const [selectedGrievanceForBreach, setSelectedGrievanceForBreach] = useState(null);
const [showPauseModal, setShowPauseModal] = useState(false);
const [selectedGrievanceForPause, setSelectedGrievanceForPause] = useState(null);
        // eslint-disable-next-line no-unused-vars
        const deletePopUp = () => {
          setIsdelete(!isdelete);
        };

        // Fetch user level from themeURL
        useEffect(() => {
          const fetchUserLevel = async () => {
            try {
              const response = await getData(getThemeURL);
              if (
                response &&
                Array.isArray(response) &&
                response.length > 0
              ) {
                setUserLevel(response[0].user_level);
                setIsAdmin(response[0].is_admin === true);
              }
            } catch (error) {
              console.error("Error fetching user level:", error);
            }
          };
          fetchUserLevel();
        }, []);
const isBreached = props.row.original.originalData?.slaBreached === true;
const isPaused = props.row.original.slaPaused === true;
console.log(props.row.original.originalData?.acceptedByL3 ,"hasBreachDate")
// Show both icons if both conditions are true
const shouldShowBreached = isBreached;
const shouldShowPaused = isPaused;

        return (
          <div
            className="usertable__actionsicon"
            style={{ display: "flex", gap: "8px", alignItems: "center" }}
          >
            {/* View Icon */}
            <span
              onClick={() =>
                navigate("/grievance/view-raise-ticket", {
                  state: { data: props.row.original },
                  device_type: true,
                })
              }
              style={{ cursor: "pointer" }}
              title='View Grievance details'
            >
              <Viewicon value={props.value} />
            </span>

             {/* Assign Ticket Icon - Only for HO Admin - UPDATED CONDITION */}
        {isAdmin === true && (
          <div
            className="action-icon assign-icon"
            onClick={() => {
      // Only allow assignment if reopenDisable is false
      if (!props.row.original.originalData?.reopenDisable && 
          props.row.original.resolvedBy !== "Closed Without Resolution") {
        openAssignModal(props.row.original);
      }
    }}
            style={{
      cursor: props.row.original.originalData?.reopenDisable || 
              props.row.original.resolvedBy === "Closed Without Resolution"
        ? "not-allowed" 
        : "pointer",
      padding: "6px",
      borderRadius: "4px",
      backgroundColor: props.row.original.originalData?.reopenDisable || 
                      props.row.original.resolvedBy === "Closed Without Resolution"
        ? "#F5F5F5" 
        : "#E3F2FD",
      border: props.row.original.originalData?.reopenDisable || 
              props.row.original.resolvedBy === "Closed Without Resolution"
        ? "1px solid #CCCCCC" 
        : "1px solid #2196F3",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
      opacity: props.row.original.originalData?.reopenDisable || 
               props.row.original.resolvedBy === "Closed Without Resolution" ? 0.5 : 1,
    }}
    onMouseEnter={(e) => {
      if (!props.row.original.originalData?.reopenDisable && 
          props.row.original.resolvedBy !== "Closed Without Resolution") {
        e.currentTarget.style.backgroundColor = "#2196F3";
        e.currentTarget.querySelector("svg").style.stroke = "white";
        e.currentTarget.style.transform = "scale(1.1)";
      }
    }}
    onMouseLeave={(e) => {
      if (!props.row.original.originalData?.reopenDisable && 
          props.row.original.resolvedBy !== "Closed Without Resolution") {
        e.currentTarget.style.backgroundColor = "#E3F2FD";
        e.currentTarget.querySelector("svg").style.stroke = "#2196F3";
        e.currentTarget.style.transform = "scale(1)";
      }
    }}
    title={
      props.row.original.originalData?.reopenDisable
        ? "This ticket cannot be assigned to any other L1 users as 36 hours have passed after closing this ticket"
        : props.row.original.resolvedBy === "Closed Without Resolution"
          ? "This ticket cannot be assigned as it was closed without resolution"
          : "Assign ticket"
    }
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke={props.row.original.originalData?.reopenDisable || 
              props.row.original.resolvedBy === "Closed Without Resolution" ? "#999999" : "#2196F3"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
          </div>
        )}
        {/* Support Admin Assign Ticket Icon - NEW */}
        {isSupportAdmin && (
          <div
            className="action-icon support-admin-assign-icon"
            onClick={() => {
              if (isSupportAdminAssignEnabled(props.row.original)) {
                openSupportAdminAssignModal(props.row.original);
              }
            }}
            style={{
              cursor: isSupportAdminAssignEnabled(props.row.original)
                ? "pointer"
                : "not-allowed",
              padding: "6px",
              borderRadius: "4px",
              backgroundColor: isSupportAdminAssignEnabled(props.row.original)
                ? "#FFF3E0"
                : "#F5F5F5",
              border: isSupportAdminAssignEnabled(props.row.original)
                ? "1px solid #FF9800"
                : "1px solid #CCCCCC",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
              opacity: isSupportAdminAssignEnabled(props.row.original) ? 1 : 0.5,
            }}
            onMouseEnter={(e) => {
              if (isSupportAdminAssignEnabled(props.row.original)) {
                e.currentTarget.style.backgroundColor = "#FF9800";
                e.currentTarget.querySelector("svg").style.stroke = "white";
                e.currentTarget.style.transform = "scale(1.1)";
              }
            }}
            onMouseLeave={(e) => {
              if (isSupportAdminAssignEnabled(props.row.original)) {
                e.currentTarget.style.backgroundColor = "#FFF3E0";
                e.currentTarget.querySelector("svg").style.stroke = "#FF9800";
                e.currentTarget.style.transform = "scale(1)";
              }
            }}
            title={
              isSupportAdminAssignEnabled(props.row.original)
                ? "Assign ticket to L2 user"
                : "Assign is available only for L2 escalation level tickets that are already assigned to an L2 user and in Open, In Progress, or Issue Pending at External Vendor status"
            }
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke={isSupportAdminAssignEnabled(props.row.original) ? "#FF9800" : "#999999"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
          </div>
        )}

{(shouldShowBreached || shouldShowPaused) && (
  <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
    {/* Breach Icon */}
    {shouldShowBreached && (
      <div
        className="action-icon breach-icon"
        onClick={() => {
          setSelectedGrievanceForBreach(props.row.original);
          setShowBreachModal(true);
        }}
        style={{
          cursor: "pointer",
          padding: "6px",
          borderRadius: "4px",
          backgroundColor: "#FFF4ED",
          border: "1px solid #F97316",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#F97316";
          e.currentTarget.querySelector("svg").style.stroke = "white";
          e.currentTarget.style.transform = "scale(1.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#FFF4ED";
          e.currentTarget.querySelector("svg").style.stroke = "#F97316";
          e.currentTarget.style.transform = "scale(1)";
        }}
        title="SLA Breached - Click for details"
      >
        <ShieldAlert size={16} color="#F97316" />
      </div>
    )}

        

       

    {/* Pause Icon */}
    {shouldShowPaused && (
      <div
        className="action-icon pause-icon"
        onClick={() => {
          setSelectedGrievanceForPause(props.row.original);
          setShowPauseModal(true);
        }}
        style={{
          cursor: "pointer",
          padding: "6px",
          borderRadius: "4px",
          backgroundColor: "#FFF8E1",
          border: "1px solid #FFC107",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease",
          animation: shouldShowPaused ? "blink 1s infinite" : "none",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#FFC107";
          e.currentTarget.querySelector("svg").style.stroke = "white";
          e.currentTarget.style.transform = "scale(1.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#FFF8E1";
          e.currentTarget.querySelector("svg").style.stroke = "#FFC107";
          e.currentTarget.style.transform = "scale(1)";
        }}
        title="SLA Paused - Click for details"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#FFC107"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="6" y="4" width="4" height="16" />
          <rect x="14" y="4" width="4" height="16" />
        </svg>
      </div>
    )}
  </div>
)}

            {/* Actions Dropdown - Only show if conditions are met */}
            <ActionsIcons
              grievance={props.row.original}
              userLevel={userLevel}
            />
{showBreachModal && (
  <div
    className="modal"
    style={{
      display: "block",
      position: "fixed",
      zIndex: 1070,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      backgroundColor: "rgba(0,0,0,0.45)",
    }}
    onClick={() => {
      setShowBreachModal(false);
      setSelectedGrievanceForBreach(null);
    }}
  >
    <div
      className="modal-dialog"
      style={{
        position: "relative",
        width: "auto",
        margin: "1.75rem auto",
        maxWidth: "560px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="modal-content"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "#fff",
          backgroundClip: "padding-box",
          border: "none",
          borderRadius: "12px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        {/* Header */}
        <div style={{ padding: "22px 24px 14px 24px" }}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
            <div>
              <h5 style={{ margin: "0 0 12px 0", fontSize: "17px", fontWeight: "700", color: "#1a1a2e" }}>
                Complaint Details – {selectedGrievanceForBreach?.id || "N/A"}
              </h5>
              {/* Status Badges */}
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                <span style={{
                  display: "inline-flex", alignItems: "center", gap: "5px",
                  padding: "3px 12px", borderRadius: "20px",
                  backgroundColor: "#FFEBEE", color: "#C62828",
                  fontSize: "12px", fontWeight: "600",
                  border: "1px solid #EF9A9A",
                }}>
                  <span style={{ width: "7px", height: "7px", borderRadius: "50%", backgroundColor: "#C62828", display: "inline-block" }} />
                  {selectedGrievanceForBreach?.status || "Open"}
                </span>
                {selectedGrievanceForBreach?.userLevels && (
                  <span style={{
                    padding: "3px 12px", borderRadius: "20px",
                    backgroundColor: "#FCE4EC", color: "#C62828",
                    fontSize: "12px", fontWeight: "600",
                    border: "1px solid #F48FB1",
                  }}>
                    {selectedGrievanceForBreach.userLevels}
                  </span>
                )}
                {selectedGrievanceForBreach?.criticality && (
                  <span style={{
                    padding: "3px 12px", borderRadius: "20px",
                    backgroundColor: "#FFF3E0", color: "#E65100",
                    fontSize: "12px", fontWeight: "600",
                    border: "1px solid #FFCC80",
                  }}>
                    {selectedGrievanceForBreach.criticality}
                  </span>
                )}
              </div>
            </div>
            <button
              type="button"
              onClick={() => {
                setShowBreachModal(false);
                setSelectedGrievanceForBreach(null);
              }}
              style={{
                width: "28px", height: "28px", borderRadius: "50%",
                border: "1px solid #D1D5DB", backgroundColor: "#fff",
                display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer", fontSize: "18px", color: "#6B7280",
                lineHeight: 1, flexShrink: 0, marginLeft: "12px",
              }}
            >
              ×
            </button>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: "1px", backgroundColor: "#E5E7EB", margin: "0 24px" }} />

        {/* Body */}
        <div style={{ padding: "20px 24px" }}>
          {/* Info Grid */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "16px 24px",
            marginBottom: "20px",
          }}>
            <div>
              <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", marginBottom: "3px", textTransform: "uppercase", letterSpacing: "0.3px" }}>Region</div>
              <div style={{ fontSize: "13px", fontWeight: "600", color: "#111827" }}>
                {selectedGrievanceForBreach?.regionName || selectedGrievanceForBreach?.bank || "N/A"}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", marginBottom: "3px", textTransform: "uppercase", letterSpacing: "0.3px" }}>Reported By</div>
              <div style={{ fontSize: "13px", fontWeight: "600", color: "#111827" }}>
                {selectedGrievanceForBreach?.requesterBy || "N/A"}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", marginBottom: "3px", textTransform: "uppercase", letterSpacing: "0.3px" }}>Assigned To</div>
              <div style={{ fontSize: "13px", fontWeight: "600", color: (!selectedGrievanceForBreach?.assignToUserName || selectedGrievanceForBreach?.assignToUserName === "Unassigned") ? "#2563EB" : "#111827" }}>
                {selectedGrievanceForBreach?.assignToUserName || "Unassigned"}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", marginBottom: "3px", textTransform: "uppercase", letterSpacing: "0.3px" }}>Resolved By</div>
              <div style={{ fontSize: "13px", fontWeight: "600", color: "#111827" }}>
                {selectedGrievanceForBreach?.resolvedBy || "Not Yet Resolved"}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", marginBottom: "3px", textTransform: "uppercase", letterSpacing: "0.3px" }}>Category</div>
              <div style={{ fontSize: "13px", fontWeight: "600", color: "#111827" }}>
                {selectedGrievanceForBreach?.issueTypeName || "N/A"}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", marginBottom: "3px", textTransform: "uppercase", letterSpacing: "0.3px" }}>Sub Category</div>
              <div style={{ fontSize: "13px", fontWeight: "600", color: "#111827" }}>
                {selectedGrievanceForBreach?.issueTypeSubCatName || "N/A"}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", marginBottom: "3px", textTransform: "uppercase", letterSpacing: "0.3px" }}>Created At</div>
              <div style={{ fontSize: "13px", fontWeight: "600", color: "#111827" }}>
                {selectedGrievanceForBreach?.date || "N/A"}
              </div>
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "#9CA3AF", fontWeight: "500", marginBottom: "3px", textTransform: "uppercase", letterSpacing: "0.3px" }}>SLA Breached At</div>
              <div style={{ fontSize: "13px", fontWeight: "600", color: "#DC3545" }}>
                {formatDateTime(selectedGrievanceForBreach?.originalData?.slaBreachedAt) || "N/A"}
              </div>
            </div>
          </div>

          {/* Divider */}
          <div style={{ height: "1px", backgroundColor: "#E5E7EB", marginBottom: "16px" }} />

          {/* Description / Action Note */}
          <div>
            <div style={{ fontSize: "12px", color: "#6B7280", fontWeight: "600", marginBottom: "8px" }}>Description</div>
            <div style={{
              padding: "12px 14px",
              backgroundColor: "#F9FAFB",
              borderRadius: "8px",
              fontSize: "13px",
              color: "#374151",
              lineHeight: "1.7",
              border: "1px solid #E5E7EB",
            }}>
              {/* SCENARIO 1: Ticket accepted by L3 */}
              {selectedGrievanceForBreach?.originalData?.acceptedByL3 &&
                selectedGrievanceForBreach?.originalData?.acceptToL3 && (
                  <>
                    This ticket has been accepted by L3{" "}
                    <strong>
                      {selectedGrievanceForBreach.originalData.acceptedByL3Name || "Unknown User"}
                    </strong>
                    . Current status is{" "}
                    <strong>{selectedGrievanceForBreach?.status || "N/A"}</strong>.
                  </>
                )}

              {/* SCENARIO 2: L3 accepted, L2 view */}
              {selectedGrievanceForBreach?.originalData?.userLevel === "L2" && (
                <>
                  This ticket was auto-escalated to L3 and then de-escalated to L2 {" "}
                  <strong>
                    {selectedGrievanceForBreach.originalData.acceptedByL3Name}
                  </strong>
                  . Current status is{" "}
                  <strong>{selectedGrievanceForBreach?.status || "N/A"}</strong>.

                  {!selectedGrievanceForBreach?.originalData?.acceptedByL2 &&
                    !selectedGrievanceForBreach?.originalData?.acceptToL2 && (
                      <>
                        <br /><br />
                        <strong>Action Required:</strong> The ticket has breached the defined SLA and is awaiting acceptance by L2. Please take immediate action.
                      </>
                    )}

                  {selectedGrievanceForBreach?.originalData?.acceptedByL2 &&
                    selectedGrievanceForBreach?.originalData?.acceptToL2 && (
                      <>
                        <br /><br />
                        <strong>L2 Update:</strong> The ticket is currently accepted by L2{" "}
                        <strong>
                          {selectedGrievanceForBreach.originalData.acceptedByL2Name || "Unknown User"}
                        </strong>.
                      </>
                    )}
                </>
              )}

              {/* SCENARIO 3: SLA breached, no acceptance */}
              {!selectedGrievanceForBreach?.originalData?.acceptedByL3 &&
                !selectedGrievanceForBreach?.originalData?.acceptToL3 &&
                selectedGrievanceForBreach?.originalData?.slaBreached && (
                  <>
                    <strong>SLA Breach Alert:</strong> This ticket has exceeded the defined SLA timeline and requires immediate attention.
                    {selectedGrievanceForBreach?.originalData?.escalateRemarks3 && (
                      <>
                        <br /><br />
                        <strong>Escalation Remarks:</strong>{" "}
                        {selectedGrievanceForBreach.originalData.escalateRemarks3}
                      </>
                    )}
                  </>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}

{/* SLA Paused Modal */}
{showPauseModal && (
  <div
    className="modal"
    style={{
      display: "block",
      position: "fixed",
      zIndex: 1070,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      backgroundColor: "rgba(0,0,0,0.4)",
    }}
    onClick={() => {
      setShowPauseModal(false);
      setSelectedGrievanceForPause(null);
    }}
  >
    <div
      className="modal-dialog"
      style={{
        position: "relative",
        width: "auto",
        margin: "1.75rem auto",
        maxWidth: "480px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="modal-content"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "#fff",
          backgroundClip: "padding-box",
          border: "1px solid rgba(0,0,0,.2)",
          borderRadius: "8px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        {/* Pause Modal Header */}
        <div
          className="modal-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 20px",
            borderBottom: "1px solid #e9ecef",
            backgroundColor: "#FFF8E1",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFECB3",
              borderRadius: "6px",
              color: "#F57C00",
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="6" y="4" width="4" height="16" />
                <rect x="14" y="4" width="4" height="16" />
              </svg>
            </div>
            <div>
              <h5 style={{
                margin: 0,
                fontSize: "16px",
                fontWeight: "600",
                color: "#F57C00",
              }}>
                SLA Paused
              </h5>
              <div style={{ fontSize: "12px", color: "#6B7280" }}>
                Ticket #{selectedGrievanceForPause?.id || "N/A"}
              </div>
            </div>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setShowPauseModal(false);
              setSelectedGrievanceForPause(null);
            }}
            style={{
              background: "black",
              border: "none",
              fontSize: "20px",
              color: "black",
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            ×
          </button>
        </div>

        {/* Pause Modal Body */}
        <div
          className="modal-body"
          style={{
            padding: "20px",
            fontFamily: "Poppins",
          }}
        >
          {/* Key Information */}
          <div style={{
            padding: "12px",
            backgroundColor: "#F9FAFB",
            borderRadius: "6px",
            borderLeft: `4px solid #F57C00`,
            marginBottom: "16px",
          }}>
            <div style={{ fontSize: "11px", color: "#6B7280", fontWeight: "500", marginBottom: "4px" }}>
              SLA Paused Date and Time
            </div>
            <div style={{ 
              fontSize: "14px", 
              fontWeight: "600", 
              color: "#F57C00" 
            }}>
              {formatDateTime(selectedGrievanceForPause?.slaPausedAt) || "N/A"}
            </div>
          </div>

          {/* Ticket Details */}
          <div style={{ marginBottom: "16px" }}>
            <div style={{ fontSize: "12px", fontWeight: "600", color: "#374151", marginBottom: "8px" }}>
              TICKET DETAILS
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "8px",
              fontSize: "13px",
            }}>
               {/* <div>
                <div style={{ color: "#6B7280", fontSize: "11px" }}>Escalation Level</div>
                <div style={{ fontWeight: "500" }}>{selectedGrievanceForPause?.userLevels || "N/A"}</div>
              </div> */}
              <div>
                <div style={{ color: "#6B7280", fontSize: "11px" }}>Priority</div>
                <div style={{ fontWeight: "500" }}>{selectedGrievanceForPause?.criticality || "N/A"}</div>
              </div>
              <div>
                <div style={{ color: "#6B7280", fontSize: "11px" }}>Status</div>
                <div style={{ fontWeight: "500" }}>{selectedGrievanceForPause?.status || "N/A"}</div>
              </div>
              <div>
                <div style={{ color: "#6B7280", fontSize: "11px" }}>Support Team</div>
                <div style={{ fontWeight: "500" }}>{selectedGrievanceForPause?.handler || "N/A"}</div>
              </div>
             
             
            </div>
          </div>

         

          {/* Action Note */}
          <div style={{
            padding: "12px",
            backgroundColor: "#FFF8E1",
            borderRadius: "6px",
            fontSize: "13px",
            color: "#F57C00",
            borderLeft: `3px solid #F57C00`,
          }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
              <span>
                The SLA timer is currently paused and will restart when the next update is made to the ticket.
              </span>
            </div>
          </div>
        </div>

        {/* Pause Modal Footer */}
        <div
          className="modal-footer"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "16px 20px",
            borderTop: "1px solid #e9ecef",
          }}
        >
          <button
            type="button"
            onClick={() => {
              setShowPauseModal(false);
              setSelectedGrievanceForPause(null);
            }}
            style={{
              padding: "8px 16px",
              backgroundColor: "#4B5563",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontFamily: "Poppins",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}
          </div>
        );
      },
    },
  ],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [t, isDepartmentAdmin, selectedGrievances, filteredComplaints, userProfile]
);
  useEffect(
    () => {
      getUserProfile();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    // Fetch user names for L1 level by default, or adjust based on your needs
    if (userId) {
      fetchUserNames(); // You can change this to dynamic user level if needed
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const getUserProfile = async () => {
  try {
    const userProfile = await getData(getThemeURL);
    setUserProfile(userProfile);
    if (userProfile && userProfile.length > 0) {
      fetchBanks(userProfile[0]);
      // Fix: API returns 'userLevel' not 'user_level'
      setUserLevel(userProfile[0]?.userLevel || userProfile[0]?.user_level || "");
    }
  } catch (error) { console.log("erer",error)}
};

  const createPayload = (profile) => {
    let admin_role = "U"; // default value

    if (profile.is_admin === true) {
      admin_role = "HO";
    } else if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    }

    return {
      admin_role: admin_role,
      bank_code: profile.bank_code || null,
      branch_code: profile.branch_code || null,
    };
  };
// eslint-disable-next-line no-unused-vars
const [isLoadingUsers, setIsLoadingUsers] = useState(false);
const fetchUserNames = async (grievance = selectedGrievance) => {
  setIsLoadingUsers(true);
  try {
    // Use the provided grievance or fall back to selectedGrievance
    const currentGrievance = grievance || selectedGrievance;
    if (!currentGrievance) {
      console.error("No grievance selected");
      setUserNames([]);
      return;
    }
    // Get bankCode and branchCode from the grievance
    const bankCode = currentGrievance.originalData?.bankCode;
    const branchCode = currentGrievance.originalData?.branchCode;
    console.log("Fetching L1 users for:", {
      bankCode,
      branchCode,
      grievanceId: currentGrievance.id
    });
    // Build the endpoint URL by replacing all placeholders
    let endpoint = getUsersByUserLevelExceptCurrent
      .replace("USERID", userId)
      .replace("BankCode", bankCode || "")
      .replace("BranchCode", branchCode || "");
    // Also replace any other possible placeholders
    endpoint = endpoint.replace("L1", "L1"); // Ensure userLevel is L1
    console.log("API URL for fetching L1 users:", endpoint);
    const response = await getData(endpoint);
    // Filter response if needed (e.g., only active users)
    const filteredUsers = response.filter(user => 
      user.is_active !== false && !user.is_deleted
    );
    setUserNames(filteredUsers);
    console.log(`Found ${filteredUsers.length} L1 users for bank ${bankCode}, branch ${branchCode}`);
  } catch (error) {
    console.error("Error fetching cross department users:", error);
    setUserNames([]);
    toast.error("Failed to load L1 users", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  } finally {
    setIsLoadingUsers(false);
  }
};

useEffect(() => {
  if (showConfirmationModal && selectedAction === "reopen" && selectedGrievance) {
    fetchUserNames(selectedGrievance);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [showConfirmationModal, selectedAction, selectedGrievance]);

  //fetch banks and branches for filters
  const fetchBanks = async (profile) => {
    try {
      const payload = createPayload(profile);
      const response = await postDataWithBody(getallBanksByRole, payload, {});
      if (response && Array.isArray(response)) {
        setBanksList(response);
      } else {
        console.error("Invalid banks data format:", response);
        toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      toast.error("Failed to load banks data");
    }
  };

  const fetchBranches = async (bankCode) => {
    try {
      const response = await getData(getbarches.replace("ID", bankCode));
      if (response && Array.isArray(response)) {
        setFilteredBranches(response);
      } else {
        console.error(
          `Invalid branches data format for bank ${bankCode}:`,
          response
        );
        setFilteredBranches([]);
      }
    } catch (error) {
      console.error(`Error fetching branches for bank ${bankCode}:`, error);
      setFilteredBranches([]);
    }
  };

  const handleBankChange = (e) => {
    const bankCode = e.target.value;
    setSelectedBankId(bankCode);
    setSelectedBranch(""); // Reset branch selection when bank changes

    if (bankCode) {
      fetchBranches(bankCode);
    } else {
      setFilteredBranches([]);
    }
  };

  useEffect(
    () => {
      if (
        isAdmin === true &&
        userProfile &&
        userProfile.length > 0 &&
        userProfile[0].bank_code
      ) {
        const bankCode = userProfile[0].bank_code.toString();
        setSelectedBankId(bankCode);
        fetchBranches(bankCode);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userRole, userProfile]
  );

  //based on the bank selection fetching branch details
  const handleBranchChange = (e) => {
    setSelectedBranch(e.target.value);
  };

  const formElementStyle = {
    height: "33px",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
    borderRadius: "8px",
    border: "1px solid #E4E7EC",
    outline: "none",
    color: "#1D2939",
    backgroundColor: "#fff",
  };

  // KPI card look shared with the Incident List screen — icon in a tinted
  // circle, bold value, uppercase micro-label.
  const kpiCardStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "8px 12px",
    borderRadius: "10px",
    border: "1px solid #EEF1F5",
    background: "#fff",
    boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
    minWidth: "150px",
  };
  const kpiIconWrapStyle = (bg) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    background: bg,
    flexShrink: 0,
  });
  const kpiLabelStyle = {
    fontSize: "9.5px",
    fontWeight: 800,
    letterSpacing: ".3px",
    textTransform: "uppercase",
    color: "#98A2B3",
    marginTop: "2px",
  };
  const kpiValueStyle = {
    fontSize: "15px",
    fontWeight: 800,
    color: "#101828",
    lineHeight: 1.1,
  };

  console.log(selectedGrievance, "selectedGrievanceselectedGrievance");

  return (
    <div className="complaint-dashboard" style={{ padding: "8px 16px 16px 16px", background: "#fff", borderRadius: "10px", minHeight: "100%" }}>
      {/* Add Loader component here - similar to BankTable */}
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      {/* Modal */}
      {showModal && (
        <div
          className="modal"
          style={{
            display: "block",
            position: "fixed",
            zIndex: 1050,
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
          onClick={closeModal}
        >
          <div
            className="modal-dialog modal-lg"
            style={{
              position: "relative",
              width: "auto",
              margin: "1.75rem auto",
              maxWidth: "800px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="modal-content"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                backgroundColor: "#fff",
                backgroundClip: "padding-box",
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "0.3rem",
                boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,.5)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  borderTopLeftRadius: "0.3rem",
                  borderTopRightRadius: "0.3rem",
                }}
              >
                <h5
                  className="modal-title"
                  style={{
                    margin: 0,
                    lineHeight: 1.5,
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                >
                  {modalTitle}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                  style={{
                    padding: 0,
                    background: "none",
                    border: 0,
                    fontSize: "1.5rem",
                    fontWeight: 700,
                    lineHeight: 1,
                    color: "#000",
                    textShadow: "0 1px 0 #fff",
                    opacity: 0.5,
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>
              </div>
              <div
                className="modal-body"
                style={{
                  position: "relative",
                  flex: "1 1 auto",
                  padding: "1rem",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  lineHeight: "1.6",
                  wordWrap: "break-word",
                  maxHeight: "400px",
                  overflowY: "auto",
                }}
              >
                {modalContent}
              </div>
              <div
                className="modal-footer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  padding: "0.75rem",
                  borderTop: "1px solid #dee2e6",
                  borderBottomRightRadius: "0.3rem",
                  borderBottomLeftRadius: "0.3rem",
                }}
              >
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                  style={{
                    backgroundColor: "#6c757d",
                    borderColor: "#6c757d",
                    color: "#fff",
                    padding: "0.375rem 0.75rem",
                    fontSize: "0.875rem",
                    lineHeight: 1.5,
                    borderRadius: "0.25rem",
                    border: "1px solid transparent",
                    cursor: "pointer",
                    fontFamily: "Poppins",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Enhanced Confirmation Modal with Multiple File Upload */}
      {showConfirmationModal && (
        <div
          className="modal"
          style={{
            display: "block",
            position: "fixed",
            zIndex: 1060,
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
          onClick={closeConfirmationModal}
        >
          <div
            className="modal-dialog"
            style={{
              position: "relative",
              width: "auto",
              margin: "1.75rem auto",
              maxWidth: selectedAction === "reopen" ? "600px" : "500px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="modal-content"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                backgroundColor: "#fff",
                backgroundClip: "padding-box",
                border: "1px solid rgba(0,0,0,.2)",
                borderRadius: "0.3rem",
                boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,.5)",
              }}
            >
              {/* Simple Confirmation for Accept Action */}
              {selectedAction === "accept" && (
                <>
                  <div
                    className="modal-header"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "1rem 1rem",
                      borderBottom: "1px solid #dee2e6",
                      borderTopLeftRadius: "0.3rem",
                      borderTopRightRadius: "0.3rem",
                    }}
                  >
                    <h5
                      className="modal-title"
                      style={{
                        margin: 0,
                        lineHeight: 1.5,
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        fontSize: "16px",
                      }}
                    >
                      Confirm Acceptance
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={closeConfirmationModal}
                      style={{
                        padding: 0,
                        background: "none",
                        border: 0,
                        fontSize: "1.5rem",
                        fontWeight: 700,
                        lineHeight: 1,
                        color: "#000",
                        textShadow: "0 1px 0 #fff",
                        opacity: 0.5,
                        cursor: "pointer",
                      }}
                    >
                      ×
                    </button>
                  </div>
                  <div
                    className="modal-body"
                    style={{
                      position: "relative",
                      flex: "1 1 auto",
                      padding: "1rem",
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      lineHeight: "1.6",
                      wordWrap: "break-word",
                    }}
                  >
                    <p style={{ margin: 0 }}>
                      Do you want to take the ownership of grievance{" "}
                      {selectedGrievance?.id}?
                    </p>
                  </div>
                  <div
                    className="modal-footer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      padding: "0.75rem",
                      borderTop: "1px solid #dee2e6",
                      borderBottomRightRadius: "0.3rem",
                      borderBottomLeftRadius: "0.3rem",
                      gap: "10px",
                    }}
                  >
                    <button
                      type="button"
                      onClick={closeConfirmationModal}
                      disabled={isAccepting}
                      style={{
                        backgroundColor: "#6c757d",
                        borderColor: "#6c757d",
                        color: "#fff",
                        fontSize: "0.875rem",
                        lineHeight: 1.5,
                        borderRadius: "0.25rem",
                        border: "1px solid transparent",
                        cursor: isAccepting ? "not-allowed" : "pointer",
                        fontFamily: "Poppins",
                        opacity: isAccepting ? 0.6 : 1,
                        padding: "0.5rem 1rem",
                        width: "110px",
                        height: "38px",
                        textAlign: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      onClick={handleActionConfirmation}
                      disabled={isAccepting}
                      style={{
                        backgroundColor: "#4899B7",
                        borderColor: "#4899B7",
                        color: "#fff",
                        fontSize: "0.875rem",
                        lineHeight: 1.5,
                        borderRadius: "0.25rem",
                        border: "1px solid transparent",
                        cursor: isAccepting ? "not-allowed" : "pointer",
                        fontFamily: "Poppins",
                        opacity: isAccepting ? 0.6 : 1,
                        padding: "0.5rem 1rem",
                        width: "110px",
                        height: "38px",
                        textAlign: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {isAccepting ? "Accepting..." : "Confirm"}
                    </button>
                  </div>
                </>
              )}

              {/* Enhanced Reopen Modal with Multiple File Upload */}
              {selectedAction === "reopen" && (
                <>
                  <div
                    className="modal-header"
                    style={{
                      borderBottom: "1px solid #e5e5e5",
                      padding: "12px 20px",
                      backgroundColor: "#f9fafb",
                      borderTopLeftRadius: "0.3rem",
                      borderTopRightRadius: "0.3rem",
                    }}
                  >
                    <h5
                      style={{
                        fontSize: "15px",
                        fontWeight: "600",
                        color: "#222",
                        margin: 0,
                        fontFamily: "Poppins",
                      }}
                    >
                      Reopen – {selectedGrievance?.id}
                    </h5>
                    <button
                      onClick={closeConfirmationModal}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: "20px",
                        color: "#555",
                        cursor: "pointer",
                        lineHeight: 1,
                      }}
                    >
                      ×
                    </button>
                  </div>

                  {/* Body */}
                  <div
                    className="modal-body"
                    style={{
                      padding: "20px",
                      fontSize: "14px",
                      color: "#333",
                      fontFamily: "Poppins",
                      maxHeight: "70vh",
                      overflowY: "auto",
                    }}
                  >
                    {[
                      ["Ticket ID", selectedGrievance?.id],
                      ["Bank Name", selectedGrievance?.bank || "N/A"],
                      ["Branch Name", selectedGrievance?.branch || "NA"],
                      ["Category", selectedGrievance?.type || "Software"],
                    ].map(([label, value]) => (
                      <div key={label} style={{ marginBottom: "10px" }}>
                        <label
                          style={{
                            display: "block",
                            fontWeight: "600",
                            marginBottom: "3px",
                            color: "#111",
                            fontSize: "13px",
                          }}
                        >
                          {label}
                        </label>
                        <input
                          type="text"
                          value={value}
                          readOnly
                          style={{
                            width: "100%",
                            border: "1px solid #dee2e6",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            backgroundColor: "#f8f9fa",
                            fontSize: "13px",
                            color: "#333",
                            fontWeight: "500",
                            fontFamily: "Poppins",
                          }}
                        />
                      </div>
                    ))}

                    <hr style={{ margin: "16px 0" }} />

                    {/* Original Closure Date */}
                    <div style={{ marginBottom: "10px" }}>
                      <label
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#333",
                        }}
                      >
                        Closure Date & Time
                      </label>
                      <input
                        type="text"
                        value={
                          selectedGrievance?.originalData.updated_on
                            ? formatDateTime(
                                selectedGrievance.originalData.updated_on
                              )
                            : "N/A"
                        }
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #dee2e6",
                          borderRadius: "6px",
                          padding: "6px 10px",
                          backgroundColor: "#f8f9fa",
                          fontSize: "13px",
                          fontFamily: "Poppins",
                        }}
                      />
                    </div>

                    {/* Enhanced Multiple File Upload Section */}
                    <div style={{ marginBottom: "14px" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "6px",
                        }}
                      >
                        <label
                          style={{
                            fontWeight: "600",
                            fontSize: "13px",
                            color: "#333",
                          }}
                        >
                          Attach Evidence / Screenshots
                        </label>
                        {selectedFiles.length > 0 && (
                          <button
                            onClick={clearAllFiles}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#ff4444",
                              fontSize: "11px",
                              cursor: "pointer",
                              textDecoration: "underline",
                              fontFamily: "Poppins",
                            }}
                          >
                            Clear All
                          </button>
                        )}
                      </div>

                      {/* Upload Area */}
                      <div
                        style={{
                          border: "2px dashed #4899B7",
                          borderRadius: "8px",
                          padding: "20px",
                          textAlign: "center",
                          backgroundColor: "#f8fbfc",
                          cursor: "pointer",
                          position: "relative",
                          transition: "all 0.3s ease",
                          marginBottom: "12px",
                        }}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                      >
                        <input
                          type="file"
                          multiple
                          accept="image/*,.png,.jpg,.jpeg,.pdf,.gif"
                          onChange={handleFileChange}
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                            cursor: "pointer",
                          }}
                        />
                        <div
                          style={{
                            fontSize: "13px",
                            color: "#666",
                            marginBottom: "8px",
                          }}
                        >
                          <div
                            style={{ fontSize: "24px", marginBottom: "8px" }}
                          >
                            📁
                          </div>
                          <div
                            style={{
                              fontWeight: "600",
                              color: "#4899B7",
                              marginBottom: "4px",
                            }}
                          >
                            Click to upload or drag and drop
                          </div>
                          <div style={{ fontSize: "12px", color: "#888" }}>
  Supports: PNG, JPG, JPEG, GIF, PDF (Max: 1MB per file, Max 5 files total)
</div>
                        </div>
                      </div>

                      {/* File Preview Section */}
                      {selectedFiles.length > 0 && (
                        <div
                          style={{
                            border: "1px solid #e0e0e0",
                            borderRadius: "6px",
                            padding: "12px",
                            backgroundColor: "#f9f9f9",
                            marginBottom: "8px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "8px",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "600",
                                fontSize: "13px",
                                color: "#333",
                              }}
                            >
                              Selected Files ({selectedFiles.length})
                            </span>
                            <div style={{ fontSize: "11px", color: "#666" }}>
                              Total:{" "}
                              {formatFileSize(
                                selectedFiles.reduce(
                                  (acc, file) => acc + file.size,
                                  0
                                )
                              )}
                            </div>
                          </div>

                           {selectedFiles.length >= 5 && (
      <div
        style={{
          backgroundColor: "#fff8e1",
          border: "1px solid #ffd54f",
          borderRadius: "4px",
          padding: "6px 8px",
          marginBottom: "8px",
          fontSize: "11px",
          color: "#ff8f00",
        }}
      >
        ⚠️ Maximum 5 files reached. Remove files to add more.
      </div>
    )}

                          <div
                            style={{ maxHeight: "200px", overflowY: "auto" }}
                          >
                            {selectedFiles.map((fileObj) => (
                              <div
                                key={fileObj.id}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  padding: "8px",
                                  backgroundColor: "white",
                                  borderRadius: "4px",
                                  border: "1px solid #e8e8e8",
                                  marginBottom: "6px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "32px",
                                    height: "32px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#4899B7",
                                    borderRadius: "4px",
                                    color: "white",
                                    flexShrink: 0,
                                  }}
                                >
                                  {getFileIcon(fileObj.type)}
                                </div>

                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div
                                    style={{
                                      fontWeight: "500",
                                      fontSize: "12px",
                                      color: "#333",
                                      marginBottom: "2px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                    title={fileObj.name}
                                  >
                                    {fileObj.name}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "10px",
                                      color: "#666",
                                    }}
                                  >
                                    {formatFileSize(fileObj.size)} •{" "}
                                    {fileObj.type
                                      .split("/")[1]
                                      ?.toUpperCase() || "FILE"}
                                  </div>
                                </div>

                                <button
                                  onClick={() => removeFile(fileObj.id)}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    color: "#ff4444",
                                    cursor: "pointer",
                                    padding: "4px",
                                    borderRadius: "3px",
                                    flexShrink: 0,
                                  }}
                                  title="Remove file"
                                >
                                  <X size={14} />
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Error Messages */}
                      {/* {fileErrors.length > 0 && (
                        <div
                          style={{
                            border: "1px solid #ffcccc",
                            borderRadius: "6px",
                            padding: "10px",
                            backgroundColor: "#fff5f5",
                            marginBottom: "8px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "12px",
                              color: "#d63031",
                              marginBottom: "6px",
                            }}
                          >
                            Rejected Files ({fileErrors.length})
                          </div>
                          {fileErrors.map((error, index) => (
                            <div
                              key={index}
                              style={{
                                fontSize: "11px",
                                color: "#d63031",
                                marginBottom: "2px",
                              }}
                            >
                              • {error.fileName}: {error.error}
                            </div>
                          ))}
                        </div>
                      )} */}

                      {/* No File Selected State */}
                      {selectedFiles.length === 0 && (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "8px",
                            color: "#999",
                            fontSize: "12px",
                            fontStyle: "italic",
                          }}
                        >
                          No files selected
                        </div>
                      )}
                    </div>

                    {/* Approved By */}
                    <div style={{ marginBottom: "10px" }}>
                      <label
                        style={{
                          display: "block",
                          fontWeight: "600",
                          marginBottom: "3px",
                          color: "#111",
                          fontSize: "13px",
                        }}
                      >
                        Support Team
                      </label>
                      <input
                        type="text"
                        value={
                          selectedGrievance?.originalData.assignedTeamName
                            ? selectedGrievance.originalData.assignedTeamName
                            : "N/A"
                        }
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #dee2e6",
                          borderRadius: "6px",
                          padding: "6px 10px",
                          backgroundColor: "#f8f9fa",
                          fontSize: "13px",
                          fontFamily: "Poppins",
                        }}
                      />
                    </div>

                    {/* Remarks */}
                    <div style={{ marginBottom: "10px" }}>
                      <label
                        style={{
                          display: "block",
                          fontWeight: "600",
                          marginBottom: "3px",
                          color: "#111",
                          fontSize: "13px",
                        }}
                      >
                        Reason for Reopening
                        <span style={{ color: "red" }}> *</span>
                      </label>

                      <textarea
                        value={reopenRemarks}
                        onChange={(e) => setReopenRemarks(e.target.value)}
                        placeholder="Enter detailed reason for reopening this ticket..."
                        style={{
                          width: "100%",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "8px 10px",
                          fontSize: "13px",
                          fontWeight: "500",
                          resize: "vertical",
                          minHeight: "80px",
                          fontFamily: "Poppins",
                        }}
                      />
                      <div
                        style={{
                          fontSize: "11px",
                          color: "#666",
                          marginTop: "4px",
                        }}
                      >
                        Please provide specific details about why this ticket
                        needs to be reopened
                      </div>
                    </div>

                    {/* Reopened To */}
                    <div style={{ marginBottom: "10px" }}>
                      <label
                        style={{
                          display: "block",
                          fontWeight: "600",
                          marginBottom: "3px",
                          color: "#111",
                          fontSize: "13px",
                        }}
                      >
                        L1 Userlist
                      </label>
                      <select
                        value={reopenedTo}
                        onChange={(e) => setReopenedTo(e.target.value)}
                        style={{
                          width: "100%",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          padding: "8px 10px",
                          fontSize: "13px",
                          fontWeight: "500",
                          fontFamily: "Poppins",
                        }}
                      >
                        <option value="">Select User</option>
                        {userNames.map((user) => (
                          <option
                            key={user.id || user.value}
                            value={user.id || user.value}
                          >
                            {user.first_name && user.last_name
                              ? `${user.first_name} ${user.last_name}`
                              : user.first_name
                                ? user.first_name
                                : user.user_name || user.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <label
                        style={{
                          display: "block",
                          fontWeight: "600",
                          marginBottom: "3px",
                          color: "#111",
                          fontSize: "13px",
                        }}
                      >
                        Requested By
                      </label>
                      <input
                        type="text"
                        value={
                          userProfile &&
                          userProfile[0]?.first_name &&
                          userProfile[0]?.last_name
                            ? `${userProfile[0].first_name} ${userProfile[0].last_name}`
                            : userProfile?.[0]?.first_name ||
                              userProfile?.[0]?.user_name ||
                              "N/A"
                        }
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #dee2e6",
                          borderRadius: "6px",
                          padding: "6px 10px",
                          backgroundColor: "#f8f9fa",
                          fontSize: "13px",
                          fontFamily: "Poppins",
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                      <label
                        style={{
                          display: "block",
                          fontWeight: "600",
                          marginBottom: "3px",
                          color: "#111",
                          fontSize: "13px",
                        }}
                      >
                        Date and Time of reopen request
                      </label>
                      <input
                        type="text"
                        value={getCurrentDateTime()}
                        readOnly
                        style={{
                          width: "100%",
                          border: "1px solid #dee2e6",
                          borderRadius: "6px",
                          padding: "6px 10px",
                          backgroundColor: "#f8f9fa",
                          fontSize: "13px",
                          fontFamily: "Poppins",
                        }}
                      />
                    </div>
                  </div>

                  {/* Footer */}
                  <div
                    className="modal-footer"
                    style={{
                      borderTop: "1px solid #e5e5e5",
                      backgroundColor: "#f9fafb",
                      padding: "12px 20px",
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "8px",
                      borderBottomRightRadius: "0.3rem",
                      borderBottomLeftRadius: "0.3rem",
                    }}
                  >
                    <button
                      onClick={closeConfirmationModal}
                      style={{
                        backgroundColor: "#6c757d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        padding: "6px 16px",
                        fontSize: "13px",
                        cursor: "pointer",
                        fontFamily: "Poppins",
                        fontWeight: "500",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleActionConfirmation}
                      disabled={isAccepting || !reopenRemarks.trim()}
                      style={{
                        backgroundColor: !reopenRemarks.trim()
                          ? "#ccc"
                          : "#4899B7",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        padding: "6px 16px",
                        fontSize: "13px",
                        cursor:
                          !reopenRemarks.trim() || isAccepting
                            ? "not-allowed"
                            : "pointer",
                        fontFamily: "Poppins",
                        fontWeight: "500",
                        opacity: isAccepting ? 0.6 : 1,
                      }}
                    >
                      {isAccepting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Assignment Modal */}
{showAssignModal && (
  <div
    className="modal"
    style={{
      display: "block",
      position: "fixed",
      zIndex: 1060,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      backgroundColor: "rgba(0,0,0,0.4)",
    }}
    onClick={closeAssignModal}
  >
    <div
      className="modal-dialog"
      style={{
        position: "relative",
        width: "auto",
        margin: "1.75rem auto",
        maxWidth: "500px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="modal-content"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "#fff",
          backgroundClip: "padding-box",
          border: "1px solid rgba(0,0,0,.2)",
          borderRadius: "0.3rem",
          boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,.5)",
        }}
      >
        {/* Header */}
        <div
          className="modal-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem 1rem",
            borderBottom: "1px solid #dee2e6",
            borderTopLeftRadius: "0.3rem",
            borderTopRightRadius: "0.3rem",
            backgroundColor: "#E3F2FD",
          }}
        >
          <h5
            className="modal-title"
            style={{
              margin: 0,
              lineHeight: 1.5,
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: "16px",
              color: "#2196F3",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
            Assign Ticket - {selectedGrievanceForAssign?.id}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeAssignModal}
            style={{
              padding: 0,
              background: "black",
              border: 0,
              fontSize: "1.5rem",
              fontWeight: 700,
              lineHeight: 1,
              color: "#000",
              textShadow: "0 1px 0 #fff",
              opacity: 0.5,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div
          className="modal-body"
          style={{
            position: "relative",
            flex: "1 1 auto",
            padding: "1.5rem",
            fontFamily: "Poppins",
            fontSize: "14px",
            lineHeight: "1.6",
          }}
        >
          {/* Ticket Info */}
          <div style={{ marginBottom: "15px" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "10px",
                backgroundColor: "#F8F9FA",
                padding: "12px",
                borderRadius: "6px",
                fontSize: "13px",
              }}
            >
              <div>
                <span style={{ color: "#666", fontWeight: "500" }}>Bank:</span>
                <br />
                <strong>{selectedGrievanceForAssign?.bank || "N/A"}</strong>
              </div>
              <div>
                <span style={{ color: "#666", fontWeight: "500" }}>Branch:</span>
                <br />
                <strong>{selectedGrievanceForAssign?.branch || "N/A"}</strong>
              </div>
            </div>
          </div>

          {/* L1 Users Dropdown */}
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "600",
                marginBottom: "6px",
                color: "#111",
                fontSize: "13px",
              }}
            >
              L1 Users <span style={{ color: "red" }}>*</span>
            </label>
            <select
              value={selectedL1User}
              onChange={(e) => setSelectedL1User(e.target.value)}
              id="l1-user-select"
              style={{
                width: "100%",
                border: "1px solid #ced4da",
                borderRadius: "6px",
                padding: "8px 10px",
                fontSize: "13px",
                fontWeight: "500",
                fontFamily: "Poppins",
              }}
            >
              <option value="">Select L1 User</option>
              {l1UsersList
  .filter(user => user.id !== selectedGrievanceForAssign?.originalData?.createdBy)
  .map((user) => (
    <option key={user.id} value={user.id}>
      {getUserDisplayName(user)}
    </option>
  ))}
            </select>
            {l1UsersList.length === 0 && (
              <div
                style={{
                  fontSize: "11px",
                  color: "#dc3545",
                  marginTop: "4px",
                }}
              >
                No L1 users available for this bank/branch
              </div>
            )}
          </div>

          {/* Assignment Description */}
          {/* Assignment Description */}
<div style={{ marginBottom: "15px" }}>
  <label
    style={{
      display: "block",
      fontWeight: "600",
      marginBottom: "6px",
      color: "#111",
      fontSize: "13px",
    }}
  >
    Assignment Description <span style={{ color: "red" }}>*</span>
  </label>
  <textarea
    value={assignmentDescription}
    onChange={(e) => {
      const inputValue = e.target.value;
      // Limit to 750 characters
      if (inputValue.length <= 750) {
        setAssignmentDescription(inputValue);
      }
    }}
    placeholder="Enter reason for assignment..."
    style={{
      width: "100%",
      border: assignmentDescription.length >= 750 ? "1px solid #dc3545" : "1px solid #ced4da",
      borderRadius: "6px",
      padding: "8px 10px",
      fontSize: "13px",
      fontWeight: "500",
      resize: "vertical",
      minHeight: "100px",
      fontFamily: "Poppins",
    }}
  />
  <div className="d-flex justify-content-between align-items-center mt-1">
    {!assignmentDescription.trim() && (
      <div className="text-danger small">Assignment description is required</div>
    )}
    <div 
      className="small ms-auto"
      style={{
        color: assignmentDescription.length >= 750 ? '#dc3545' : '#6c757d',
        fontWeight: assignmentDescription.length >= 750 ? '600' : 'normal'
      }}
    >
      {assignmentDescription.length}/750 characters
      {assignmentDescription.length >= 750 && (
        <span className="ms-2 text-danger">
          <i className="bi bi-exclamation-triangle"></i> Character limit reached
        </span>
      )}
    </div>
  </div>
</div>

{/* Footer - Update the Submit button */}
<div
  className="modal-footer"
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0.75rem",
    borderTop: "1px solid #dee2e6",
    borderBottomRightRadius: "0.3rem",
    borderBottomLeftRadius: "0.3rem",
    gap: "10px",
  }}
>
  <button
    type="button"
    onClick={closeAssignModal}
    disabled={isAssigning}
    style={{
      backgroundColor: "#6c757d",
      borderColor: "#6c757d",
      color: "#fff",
      fontSize: "0.875rem",
      lineHeight: 1.5,
      borderRadius: "0.25rem",
      border: "1px solid transparent",
      cursor: isAssigning ? "not-allowed" : "pointer",
      fontFamily: "Poppins",
      opacity: isAssigning ? 0.6 : 1,
      padding: "0.5rem 1rem",
    }}
  >
    Cancel
  </button>
  <button
    type="button"
    onClick={handleAssignSubmit}
    disabled={
      isAssigning || 
      !selectedL1User || 
      !assignmentDescription.trim() || 
      assignmentDescription.length >= 750
    }
    style={{
      backgroundColor: 
        !selectedL1User || 
        !assignmentDescription.trim() || 
        assignmentDescription.length >= 750
          ? "#ccc" 
          : "#2196F3",
      borderColor: 
        !selectedL1User || 
        !assignmentDescription.trim() || 
        assignmentDescription.length >= 750
          ? "#ccc"
          : "#2196F3",
      color: "#fff",
      fontSize: "0.875rem",
      lineHeight: 1.5,
      borderRadius: "0.25rem",
      border: "1px solid transparent",
      cursor:
        isAssigning || 
        !selectedL1User || 
        !assignmentDescription.trim() || 
        assignmentDescription.length >= 750
          ? "not-allowed"
          : "pointer",
      fontFamily: "Poppins",
      opacity: isAssigning ? 0.6 : 1,
      padding: "0.5rem 1rem",
    }}
  >
    {isAssigning ? "Assigning..." : "Submit"}
  </button>
</div>
</div>
      </div>
    </div>
  </div>
)}

{/* Support Admin Assignment Modal - NEW */}
{showSupportAdminAssignModal && (
  <div
    className="modal"
    style={{
      display: "block",
      position: "fixed",
      zIndex: 1060,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      backgroundColor: "rgba(0,0,0,0.4)",
    }}
    onClick={closeSupportAdminAssignModal}
  >
    <div
      className="modal-dialog"
      style={{
        position: "relative",
        width: "auto",
        margin: "1.75rem auto",
        maxWidth: "500px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="modal-content"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "#fff",
          backgroundClip: "padding-box",
          border: "1px solid rgba(0,0,0,.2)",
          borderRadius: "0.3rem",
          boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,.5)",
        }}
      >
        {/* Header */}
        <div
          className="modal-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem 1rem",
            borderBottom: "1px solid #dee2e6",
            borderTopLeftRadius: "0.3rem",
            borderTopRightRadius: "0.3rem",
            backgroundColor: "#FFF3E0",
          }}
        >
          <h5
            className="modal-title"
            style={{
              margin: 0,
              lineHeight: 1.5,
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: "16px",
              color: "#FF9800",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
            Assign Ticket (L2) - {selectedGrievanceForSupportAdminAssign?.id}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeSupportAdminAssignModal}
            style={{
              padding: 0,
              background: "black",
              border: 0,
              fontSize: "1.5rem",
              fontWeight: 700,
              lineHeight: 1,
              color: "#000",
              textShadow: "0 1px 0 #fff",
              opacity: 0.5,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div
          className="modal-body"
          style={{
            position: "relative",
            flex: "1 1 auto",
            padding: "1.5rem",
            fontFamily: "Poppins",
            fontSize: "14px",
            lineHeight: "1.6",
          }}
        >
          {/* Ticket Info */}
          <div style={{ marginBottom: "15px" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "10px",
                backgroundColor: "#F8F9FA",
                padding: "12px",
                borderRadius: "6px",
                fontSize: "13px",
              }}
            >
              <div>
                <span style={{ color: "#666", fontWeight: "500" }}>Bank:</span>
                <br />
                <strong>{selectedGrievanceForSupportAdminAssign?.bank || "N/A"}</strong>
              </div>
              <div>
                <span style={{ color: "#666", fontWeight: "500" }}>Branch:</span>
                <br />
                <strong>{selectedGrievanceForSupportAdminAssign?.branch || "N/A"}</strong>
              </div>
              <div>
                <span style={{ color: "#666", fontWeight: "500" }}>Current Assignee:</span>
                <br />
                <strong>{selectedGrievanceForSupportAdminAssign?.assignToUserName || "Unassigned"}</strong>
              </div>
              <div>
                <span style={{ color: "#666", fontWeight: "500" }}>Status:</span>
                <br />
                <strong>{selectedGrievanceForSupportAdminAssign?.status || "N/A"}</strong>
              </div>
            </div>
          </div>

          {/* L2 Users Dropdown */}
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "600",
                marginBottom: "6px",
                color: "#111",
                fontSize: "13px",
              }}
            >
              Assign To (L2 User) <span style={{ color: "red" }}>*</span>
            </label>
            <select
              value={selectedSupportAdminUser}
              onChange={(e) => setSelectedSupportAdminUser(e.target.value)}
              id="support-admin-assign-user-select"
              style={{
                width: "100%",
                border: "1px solid #ced4da",
                borderRadius: "6px",
                padding: "8px 10px",
                fontSize: "13px",
                fontWeight: "500",
                fontFamily: "Poppins",
              }}
            >
              <option value="">Select L2 User</option>
              {supportAdminUsersList
                .filter(user => {
        // Filter out the current assignee using assignToUserId from originalData
        const currentAssigneeId = selectedGrievanceForSupportAdminAssign?.originalData?.assignToUserId;
        // Convert both to strings for comparison since assignToUserId might be a string
        return user.id.toString() !== currentAssigneeId?.toString();
      })
                .map((user) => (
                  <option key={user.id} value={user.id}>
                    {getSupportAdminUserDisplayName(user)}
                  </option>
                ))}
            </select>
            {supportAdminUsersList.filter(user => {
    const currentAssigneeId = selectedGrievanceForSupportAdminAssign?.originalData?.assignToUserId;
    return user.id.toString() !== currentAssigneeId?.toString();
  }).length === 0 && (
              <div
                style={{
                  fontSize: "11px",
                  color: "#dc3545",
                  marginTop: "4px",
                }}
              >
                No L2 users available
              </div>
            )}
          </div>

          {/* Assignment Description */}
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "600",
                marginBottom: "6px",
                color: "#111",
                fontSize: "13px",
              }}
            >
              Assignment Description <span style={{ color: "red" }}>*</span>
            </label>
            <textarea
              value={supportAdminAssignmentDescription}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 750) {
                  setSupportAdminAssignmentDescription(inputValue);
                }
              }}
              placeholder="Enter reason for assignment..."
              style={{
                width: "100%",
                border: supportAdminAssignmentDescription.length >= 750 ? "1px solid #dc3545" : "1px solid #ced4da",
                borderRadius: "6px",
                padding: "8px 10px",
                fontSize: "13px",
                fontWeight: "500",
                resize: "vertical",
                minHeight: "100px",
                fontFamily: "Poppins",
              }}
            />
            <div className="d-flex justify-content-between align-items-center mt-1">
              {!supportAdminAssignmentDescription.trim() && (
                <div className="text-danger small">Assignment description is required</div>
              )}
              <div 
                className="small ms-auto"
                style={{
                  color: supportAdminAssignmentDescription.length >= 750 ? '#dc3545' : '#6c757d',
                  fontWeight: supportAdminAssignmentDescription.length >= 750 ? '600' : 'normal'
                }}
              >
                {supportAdminAssignmentDescription.length}/750 characters
                {supportAdminAssignmentDescription.length >= 750 && (
                  <span className="ms-2 text-danger">
                    <i className="bi bi-exclamation-triangle"></i> Character limit reached
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          className="modal-footer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0.75rem",
            borderTop: "1px solid #dee2e6",
            borderBottomRightRadius: "0.3rem",
            borderBottomLeftRadius: "0.3rem",
            gap: "10px",
          }}
        >
          <button
            type="button"
            onClick={closeSupportAdminAssignModal}
            disabled={isSupportAdminAssigning}
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "#fff",
              fontSize: "0.875rem",
              lineHeight: 1.5,
              borderRadius: "0.25rem",
              border: "1px solid transparent",
              cursor: isSupportAdminAssigning ? "not-allowed" : "pointer",
              fontFamily: "Poppins",
              opacity: isSupportAdminAssigning ? 0.6 : 1,
              padding: "0.5rem 1rem",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSupportAdminAssignSubmit}
            disabled={
              isSupportAdminAssigning || 
              !selectedSupportAdminUser || 
              !supportAdminAssignmentDescription.trim() || 
              supportAdminAssignmentDescription.length >= 750
            }
            style={{
              backgroundColor: 
                !selectedSupportAdminUser || 
                !supportAdminAssignmentDescription.trim() || 
                supportAdminAssignmentDescription.length >= 750
                  ? "#ccc" 
                  : "#FF9800",
              borderColor: 
                !selectedSupportAdminUser || 
                !supportAdminAssignmentDescription.trim() || 
                supportAdminAssignmentDescription.length >= 750
                  ? "#ccc"
                  : "#FF9800",
              color: "#fff",
              fontSize: "0.875rem",
              lineHeight: 1.5,
              borderRadius: "0.25rem",
              border: "1px solid transparent",
              cursor:
                isSupportAdminAssigning || 
                !selectedSupportAdminUser || 
                !supportAdminAssignmentDescription.trim() || 
                supportAdminAssignmentDescription.length >= 750
                  ? "not-allowed"
                  : "pointer",
              fontFamily: "Poppins",
              opacity: isSupportAdminAssigning ? 0.6 : 1,
              padding: "0.5rem 1rem",
            }}
          >
            {isSupportAdminAssigning ? "Assigning..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    <div
    className="filter-row d-flex align-items-center mb-2"
    style={{
      gap: "10px",
      padding: "10px 16px 8px 16px",
      background: "#fff",
      borderRadius: "10px 10px 0 0",
      border: "1px solid #EEF1F5",
      borderBottom: "none",
      boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
    }}
  >
    {/* Total Complaints stat card */}
    <div className="stat-card" style={kpiCardStyle}>
      <span style={kpiIconWrapStyle("#EBF4FF")}>
        <ListChecks color="#3579D4" width={15} height={15} />
      </span>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span style={kpiValueStyle}>{totalComplaints}</span>
        <span style={kpiLabelStyle}>Total Complaints</span>
      </div>
    </div>

    <div className="stat-card" style={kpiCardStyle}>
      <span style={kpiIconWrapStyle("#FFF4EA")}>
        <Clock color="#D4772A" width={15} height={15} />
      </span>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span style={{ ...kpiValueStyle, color: "#D4772A" }}>{pendingComplaints}</span>
        <span style={kpiLabelStyle}>Pending</span>
      </div>
    </div>

    {/* Spacer to push search to the right */}
    <div style={{ flex: 1 }}></div>

    {/* Search */}
    <div className="search-container" style={{ maxWidth: "260px", width: "100%" }}>
      <div
        className="d-flex align-items-center"
        style={{
          height: "33px",
          border: "1px solid #d1dde8",
          borderRadius: "6px",
          background: "#fff",
          overflow: "hidden",
          boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        }}
      >
        <input
          type="text"
          placeholder="Search complaints..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="flex-grow-1"
          style={{
            fontSize: "12px",
            border: "none",
            outline: "none",
            boxShadow: "none",
            background: "transparent",
            width: "100%",
            height: "100%",
            padding: "0 10px",
            fontFamily: "Poppins",
            color: "#2c3e50",
          }}
        />
        <div style={{ height: "100%", display: "flex", alignItems: "center", padding: "0 10px", borderLeft: "1px solid #e8eef4" }}>
          <Search size={13} color="#4899B7" />
        </div>
      </div>
    </div>
  </div>

  {/* LINE 2: Reported By, Resolved By, Status, Categories, Bank, Branch */}
 {/* LINE 2: Reported By, Resolved By, Status, Categories, Bank, Branch */}
<div
  className="second-row align-items-center mb-3"
  style={{ gap: "12px", paddingLeft: "30px", display: "none" }}
>
  {/* User dropdown - Reported By */}
  {/* <div className="filter-dropdown">
    <select
      className="form-select"
      value={reportedBy}
      title={
        reportedBy 
          ? (() => {
              const user = (reportedByUsers || []).find(u => u.id === parseInt(reportedBy));
              if (user) {
                const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
                return fullName || user.user_name || 'Unknown User';
              }
              return 'Reported By';
            })()
          : 'Reported By'
      }
      onChange={(e) => setReportedBy(e.target.value)}
      style={{
        ...formElementStyle,
        width: "148px",
      }}
    >
      <option value="">Reported By</option>
      {(reportedByUsers || [])
  .filter(user => user.status !== false && !user.is_deleted)
  .map((user) => {
    const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
    const displayName = fullName || user.user_name || 'Unknown User';
    return { id: user.id, displayName };
  })
  .sort((a, b) => a.displayName.localeCompare(b.displayName))
  .map((user) => (
    <option key={user.id} value={user.id}>
      {user.displayName}
    </option>
  ))}
    </select>
  </div> */}

  {/* User dropdown - Resolved By */}
{/* User dropdown - Resolved By */}
{/* <div className="filter-dropdown">
  <select
    className="form-select"
    value={resolvedBy}
    title={
      resolvedBy 
        ? (() => {
            // Check if it's the special "Closed Without Resolution" value
            if (resolvedBy === "Closed Without Resolution") {
              return "Closed Without Resolution";
            }
            const filteredUsers = resolvedByUsers || [];
            const user = filteredUsers.find(u => u.id === parseInt(resolvedBy));
            if (user) {
              const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
              return fullName || user.user_name || 'Unknown User';
            }
            return 'Resolved By';
          })()
        : 'Resolved By'
    }
    onChange={(e) => setResolvedBy(e.target.value)}
    style={{
      ...formElementStyle,
      width: "148px",
    }}
  >
    <option value="">Resolved By</option>
    {(resolvedByUsers || [])
  .filter(user => user.status !== false && !user.is_deleted)
  .map((user) => {
    const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
    const displayName = fullName || user.user_name || 'Unknown User';
    return { id: user.id, displayName };
  })
  .sort((a, b) => a.displayName.localeCompare(b.displayName))
  .map((user) => (
    <option key={user.id} value={user.id}>
      {user.displayName}
    </option>
  ))}
  </select>
</div> */}

  {/* Status dropdown */}
  <div className="filter-dropdown">
    <select
      className="form-select"
      value={statusFilter}
      title={statusFilter === "Status - All" ? "All" : statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      style={{
        ...formElementStyle,
        width: "148px",
      }}
    >
      {statusOptions.map((option) => (
        <option key={option} value={option}>
          {option === "Status - All" ? "All" : option}
        </option>
      ))}
    </select>
  </div>

  {/* Category dropdown */}
{/* <div className="filter-dropdown">
  <select
    className="form-select"
    value={selectedCategory}
    title={selectedCategory}
    onChange={(e) => setSelectedCategory(e.target.value)}
    disabled={(() => {
      let filteredCategories = issueTypes;
      if (shouldApplyDepartmentFilter()) {
        filteredCategories = issueTypes.filter(issue => 
          issue.department_id === userDepartmentId
        );
      }
      return filteredCategories.length <= 1;
    })()}
    style={{
      ...formElementStyle,
      width: "148px",
      borderRadius: "5px", // Add curved edges
      backgroundColor: (() => {
        let filteredCategories = issueTypes;
        if (shouldApplyDepartmentFilter()) {
          filteredCategories = issueTypes.filter(issue => 
            issue.department_id === userDepartmentId
          );
        }
        return filteredCategories.length <= 1 ? '#f8f9fa' : '#ffffff';
      })(),
      border: (() => {
        let filteredCategories = issueTypes;
        if (shouldApplyDepartmentFilter()) {
          filteredCategories = issueTypes.filter(issue => 
            issue.department_id === userDepartmentId
          );
        }
        return filteredCategories.length <= 1 ? '1px solid #dee2e6' : '1px solid #ced4da';
      })(),
      cursor: (() => {
        let filteredCategories = issueTypes;
        if (shouldApplyDepartmentFilter()) {
          filteredCategories = issueTypes.filter(issue => 
            issue.department_id === userDepartmentId
          );
        }
        return filteredCategories.length <= 1 ? 'not-allowed' : 'pointer';
      })(),
      opacity: (() => {
        let filteredCategories = issueTypes;
        if (shouldApplyDepartmentFilter()) {
          filteredCategories = issueTypes.filter(issue => 
            issue.department_id === userDepartmentId
          );
        }
        return filteredCategories.length <= 1 ? 0.7 : 1;
      })(),
    }}
  >
    {(() => {
      let filteredCategories = issueTypes;
      
      if (shouldApplyDepartmentFilter()) {
        filteredCategories = issueTypes.filter(issue => 
          issue.department_id === userDepartmentId
        );
      }
      
      // Only show "All Categories" option if there are multiple categories
      if (filteredCategories.length > 1) {
        return (
          <>
            <option value="All Categories">All Categories</option>
            {filteredCategories.map((issue) => (
              <option key={issue.id} value={issue.value}>
                {issue.value}
              </option>
            ))}
          </>
        );
      } else if (filteredCategories.length === 1) {
        return (
          <option value={filteredCategories[0].value}>
            {filteredCategories[0].value}
          </option>
        );
      } else {
        return <option value="All Categories">No Categories Available</option>;
      }
    })()}
  </select>
</div> */}
  
  {/* Escalation Level dropdown */}
  {userProfile?.[0]?.role_name !== "Citizen" && (
  <div className="filter-dropdown">
    <select
      className="form-select"
      value={priorityLevel}
      title={priorityLevel || "All"}
      onChange={(e) => setPriorityLevel(e.target.value)}
      style={{
        ...formElementStyle,
        width: "148px",
        color: "#212529",
      }}
    >
      <option value="">All</option>
      <option value="L2">L2</option>
      <option value="L3">L3</option>
    </select>
  </div>
  )}

 {/* Department dropdown */}
{/* <div className="filter-dropdown">
  <select
    className="form-select"
    value={selectedDepartment}
    title={
      selectedDepartment 
        ? (() => {
            let filteredDepts = allDepartments.filter(dept => !dept.is_deleted && dept.is_helpdesk === true);
            
            if (shouldApplyDepartmentFilter()) {
              filteredDepts = filteredDepts.filter(dept => dept.id === userDepartmentId);
            }
            
            return filteredDepts.find(d => d.id === parseInt(selectedDepartment))?.name || 'Support Team';
          })()
        : 'Support Team'
    }
    onChange={(e) => setSelectedDepartment(e.target.value)}
    disabled={(() => {
      let filteredDepts = allDepartments.filter(dept => !dept.is_deleted && dept.is_helpdesk === true);
      if (shouldApplyDepartmentFilter()) {
        filteredDepts = filteredDepts.filter(dept => dept.id === userDepartmentId);
      }
      return filteredDepts.length <= 1;
    })()}
    style={{
      ...formElementStyle,
      width: "148px",
      borderRadius: "5px", // Add curved edges
      backgroundColor: (() => {
        let filteredDepts = allDepartments.filter(dept => !dept.is_deleted && dept.is_helpdesk === true);
        if (shouldApplyDepartmentFilter()) {
          filteredDepts = filteredDepts.filter(dept => dept.id === userDepartmentId);
        }
        return filteredDepts.length <= 1 ? '#f8f9fa' : '#ffffff';
      })(),
      border: (() => {
        let filteredDepts = allDepartments.filter(dept => !dept.is_deleted && dept.is_helpdesk === true);
        if (shouldApplyDepartmentFilter()) {
          filteredDepts = filteredDepts.filter(dept => dept.id === userDepartmentId);
        }
        return filteredDepts.length <= 1 ? '1px solid #dee2e6' : '1px solid #ced4da';
      })(),
      cursor: (() => {
        let filteredDepts = allDepartments.filter(dept => !dept.is_deleted && dept.is_helpdesk === true);
        if (shouldApplyDepartmentFilter()) {
          filteredDepts = filteredDepts.filter(dept => dept.id === userDepartmentId);
        }
        return filteredDepts.length <= 1 ? 'not-allowed' : 'pointer';
      })(),
      opacity: (() => {
        let filteredDepts = allDepartments.filter(dept => !dept.is_deleted && dept.is_helpdesk === true);
        if (shouldApplyDepartmentFilter()) {
          filteredDepts = filteredDepts.filter(dept => dept.id === userDepartmentId);
        }
        return filteredDepts.length <= 1 ? 0.7 : 1;
      })(),
    }}
  >
    {(() => {
      let filteredDepts = allDepartments.filter(dept => !dept.is_deleted && dept.is_helpdesk === true);
      
      // Apply department filter for Support Admin, L2, L3
      if (shouldApplyDepartmentFilter()) {
        filteredDepts = filteredDepts.filter(dept => dept.id === userDepartmentId);
      }
      
      // Only show "Support Team" option if there are multiple departments
      if (filteredDepts.length > 1) {
        return (
          <>
            <option value="">Support Team</option>
            {filteredDepts
  .sort((a, b) => a.name.localeCompare(b.name))
  .map((department) => (
    <option key={department.id} value={department.id}>
      {department.name}
    </option>
  ))}
          </>
        );
      } else if (filteredDepts.length === 1) {
        return (
          <option value={filteredDepts[0].id}>
            {filteredDepts[0].name}
          </option>
        );
      } else {
        return <option value="">No Departments Available</option>;
      }
    })()}
  </select>
</div> */}
</div>

  

  {/* Filters Row: Status, Escalation Level, Date Range, and Action Buttons */}
  <div
    className="third-row d-flex align-items-center mb-3"
    style={{
      gap: "8px",
      padding: "8px 16px",
      flexWrap: "wrap",
      background: "#F9FAFB",
      borderRadius: "0 0 10px 10px",
      border: "1px solid #EEF1F5",
      borderTop: "none",
    }}
  >

    {/* Status dropdown */}
    <div className="filter-dropdown d-flex align-items-center" style={{ gap: "4px" }}>
      <label
        htmlFor="status-filter"
        style={{
          fontSize: "11px",
          fontWeight: "600",
          color: "#7a90a4",
          whiteSpace: "nowrap",
          textTransform: "uppercase",
          letterSpacing: "0.02em",
        }}
      >
        Status:
      </label>
      <select
        id="status-filter"
        className="form-select"
        value={statusFilter}
        title={statusFilter === "Status - All" ? "All" : statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
        style={{
          ...formElementStyle,
          width: "120px",
        }}
      >
        {statusOptions.map((option) => (
          <option key={option} value={option}>
            {option === "Status - All" ? "All" : option}
          </option>
        ))}
      </select>
    </div>

    {/* Escalation Level dropdown */}
    {userProfile?.[0]?.role_name !== "Citizen" && (
    <div className="filter-dropdown d-flex align-items-center" style={{ gap: "4px" }}>
      <label
        htmlFor="escalation-filter"
        style={{
          fontSize: "11px",
          fontWeight: "600",
          color: "#7a90a4",
          whiteSpace: "nowrap",
          textTransform: "uppercase",
          letterSpacing: "0.02em",
        }}
      >
        Escalation:
      </label>
      <select
        id="escalation-filter"
        className="form-select"
        value={priorityLevel}
        title={priorityLevel || "All"}
        onChange={(e) => setPriorityLevel(e.target.value)}
        style={{
          ...formElementStyle,
          width: "80px",
          color: "#212529",
        }}
      >
        <option value="">All</option>
        <option value="L2">L2</option>
        <option value="L3">L3</option>
      </select>
    </div>
    )}

    {/* Date Range Filters */}
<div className="date-filter d-flex align-items-center" style={{ gap: "8px" }}>
  {/* From Date with label */}
  <div className="date-input-group d-flex align-items-center" style={{ gap: "4px" }}>
    <label
      htmlFor="from-date"
      style={{
        fontSize: "11px",
        fontWeight: "600",
        color: "#7a90a4",
        whiteSpace: "nowrap",
        textTransform: "uppercase",
        letterSpacing: "0.02em",
      }}
    >
      From:
    </label>
   <input
  id="from-date"
  type="date"
  value={tempFromDate}
  title={tempFromDate || "Select from date"}
  onChange={handleFromDateChange}
  onBlur={() => validateDateOnBlur('from')}  // Add this
  max={new Date().toISOString().split('T')[0]}
  style={{
    ...formElementStyle,
    width: "138px",
    padding: "0px 10px",
    border: "1px solid #ced4da",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
}}
/>
  </div>
  
  {/* To Date with label */}
  <div className="date-input-group d-flex align-items-center" style={{ gap: "4px" }}>
    <label
      htmlFor="to-date"
      style={{
        fontSize: "11px",
        fontWeight: "600",
        color: "#7a90a4",
        whiteSpace: "nowrap",
        textTransform: "uppercase",
        letterSpacing: "0.02em",
      }}
    >
      To:
    </label>
    <input
  id="to-date"
  type="date"
  value={tempToDate}
  title={tempToDate || "Select to date"}
  onChange={handleToDateChange}
  onBlur={() => validateDateOnBlur('to')}  // Add this
  min={tempFromDate}
  max={new Date().toISOString().split('T')[0]}
  disabled={!tempFromDate}
  style={{
    ...formElementStyle,
    width: "138px",
    padding: "0px 10px",
    border: "1px solid #ced4da",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
}}
/>
  </div>
  {/* Apply Button */}
  <button
    onClick={handleApplyDateFilter}
    disabled={!tempFromDate || !tempToDate}
    style={{
      padding: "0 14px",
      backgroundColor: (!tempFromDate || !tempToDate) ? "#c5d4df" : "#2A6591",
      color: "white",
      border: "none",
      borderRadius: "6px",
      cursor: (!tempFromDate || !tempToDate) ? "not-allowed" : "pointer",
      fontWeight: "600",
      height: "33px",
      fontSize: "11px",
      fontFamily: "Poppins",
      opacity: (!tempFromDate || !tempToDate) ? 0.7 : 1,
      transition: "background 0.15s ease",
      whiteSpace: "nowrap",
      letterSpacing: "0.02em",
    }}
    title={(!tempFromDate || !tempToDate) ? "Select both dates to apply filter" : "Apply date filter"}
  >
    Apply
  </button>
</div>
     {/* Bank dropdown */}
    {(userRole === "SUPER ADMIN" || isAdmin === true) && (
      <div
        className="filter-dropdown"
        style={{ display: isAdmin === true ? "none" : "block" }}
      >
        <select
          className="form-select"
          value={selectedBankId}
          title={
          selectedBankId 
  ? banksList.find(b => String(b.bankCode) === String(selectedBankId))?.name || 
    banksList.find(b => String(b.bankCode) === String(selectedBankId))?.bankNameShort ||
              'All Banks'
            : 'All Banks'
        }
          onChange={handleBankChange}
          style={{
            ...formElementStyle,
            width: "148px",
          }}
        >
          <option value="">All Banks</option>
          {banksList.map((bank) => (
            <option key={bank.bankCode} value={bank.bankCode}>
              {bank.name || bank.bankNameShort}
            </option>
          ))}
        </select>
      </div>
    )}

    {/* Branch dropdown */}
    {(userRole === "SUPER ADMIN" || isAdmin === true) && (
      <div className="filter-dropdown">
        <select
          className="form-select"
          value={selectedBranch}
          title={
          selectedBranch 
            ? filteredBranches.find(b => b.branchCode === parseInt(selectedBranch))?.name || 
              filteredBranches.find(b => b.branchCode === parseInt(selectedBranch))?.branchNameShort || 
              'All Branches'
            : !selectedBankId || filteredBranches.length === 0 
              ? 'Select a bank first' 
              : 'All Branches'
        }
          onChange={handleBranchChange}
          style={{
            ...formElementStyle,
            width: "148px",
            backgroundColor: !selectedBankId || filteredBranches.length === 0 ? '#f8f9fa' : '#ffffff',
            color: !selectedBankId || filteredBranches.length === 0 ? '#6c757d' : '#000000',
            cursor: !selectedBankId || filteredBranches.length === 0 ? 'not-allowed' : 'pointer',
            opacity: !selectedBankId || filteredBranches.length === 0 ? 0.7 : 1,
            borderRadius: "5px",
            border: "1px solid #ced4da"
          }}
          disabled={!selectedBankId || filteredBranches.length === 0}
        >
          <option value="">All Branches</option>
          {filteredBranches.map((branch) => (
            <option key={branch.branchCode} value={branch.branchCode}>
              {branch.name || branch.branchNameShort}
            </option>
          ))}
        </select>
      </div>
    )}

    {/* Spacer to push buttons to the right */}
    <div style={{ flex: 1 }}></div>

    {/* Action buttons */}
    <div
      style={{
        display: "flex",
        gap: "8px",
        alignItems: "center",
        marginRight: "10pt",
      }}
    >
      {/* ADD BULK ASSIGN BUTTON HERE - BEFORE REFRESH BUTTON */}
  {isDepartmentAdmin && selectedGrievances.length > 0 && (
    <button
      onClick={openBulkAssignModal}
      disabled={isBulkAssigning || loader}
      style={{
        padding: "8px 12px",
        backgroundColor: "#4899B7",
        color: "white",
        border: "none",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        cursor: isBulkAssigning || loader ? "not-allowed" : "pointer",
        fontWeight: "500",
        height: "36px",
        fontSize: "12px",
        opacity: isBulkAssigning || loader ? 0.6 : 1,
      }}
      title={`Assign ${selectedGrievances.length} selected ticket(s)`}
    >
      <UserPlus size={14} />
      Assign ({selectedGrievances.length})
    </button>
  )}
     {/* Reset/Refresh button */}
      <button
        onClick={handleRefresh}
        disabled={isRefreshing || loader}
        style={{
          padding: "8px 12px",
          backgroundColor: "#6c757d",
          color: "white",
          border: "none",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: isRefreshing || loader ? "not-allowed" : "pointer",
          fontWeight: "500",
          height: "36px",
          fontSize: "12px",
          opacity: isRefreshing || loader ? 0.6 : 1,
          marginLeft: userProfile && userProfile[0] && ["L2", "L3"].includes(userProfile[0].user_level) ? "-50px" : "0px",
        }}
        title="Refresh data"
      >
        <RefreshCcw
          id="refresh-icon"
          size={14}
          className={isRefreshing ? "spin-animation" : ""}
          style={{
            animation: isRefreshing ? "spin 1s linear infinite" : "none",
          }}
        />
      </button>

      {/* Reset Filters button */}
      <button
        onClick={clearAllFilters}
        disabled={loader}
        style={{
          padding: "8px 12px",
          backgroundColor: "#FF6B35",
          color: "white",
          border: "none",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: loader ? "not-allowed" : "pointer",
          fontWeight: "500",
          height: "36px",
          fontSize: "12px",
          opacity: loader ? 0.6 : 1,
        }}
        title="Reset all filters"
      >
<FilterX size={14} />
      </button>

      {/* Excel Download Button */}
      {userProfile && userProfile[0] && !["L2", "L3"].includes(userProfile[0].user_level) && userProfile[0].role_name !== "Citizen" && (
      <button
        onClick={downloadExcel}
        style={{
          padding: "8px 12px",
          backgroundColor: "#10B981",
          color: "white",
          border: "none",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
          fontWeight: "500",
          height: "36px",
          fontSize: "12px",
        }}
        title="Export to Excel"
      >
        <Download size={14} />
        <Sheet size={14} />
        {/* Export */}
      </button>)}

      {/* PDF Download Button */}
      {userProfile && userProfile[0] && !["L2", "L3"].includes(userProfile[0].user_level) && userProfile[0].role_name !== "Citizen" && (
      <button
        onClick={downloadPDF}
        style={{
          padding: "8px 12px",
          backgroundColor: "#EF4444",
          color: "white",
          border: "none",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
          fontWeight: "500",
          height: "36px",
          fontSize: "12px",
        }}
        title="Export to PDF"
      >
        <Download size={14} />
        <FileTextIcon size={14} />
        {/* PDF */}
      </button>)}
    </div>
    {/* Bulk Assignment Modal */}
{showBulkAssignModal && (
  <div
    className="modal"
    style={{
      display: "block",
      position: "fixed",
      zIndex: 1070,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      backgroundColor: "rgba(0,0,0,0.4)",
    }}
    onClick={closeBulkAssignModal}
  >
    <div
      className="modal-dialog"
      style={{
        position: "relative",
        width: "auto",
        margin: "1.75rem auto",
        maxWidth: "500px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="modal-content"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "#fff",
          backgroundClip: "padding-box",
          border: "1px solid rgba(0,0,0,.2)",
          borderRadius: "0.3rem",
          boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,.5)",
        }}
      >
        {/* Header */}
        <div
          className="modal-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1rem 1rem",
            borderBottom: "1px solid #dee2e6",
            borderTopLeftRadius: "0.3rem",
            borderTopRightRadius: "0.3rem",
            backgroundColor: "#E3F2FD",
          }}
        >
          <h5
            className="modal-title"
            style={{
              margin: 0,
              lineHeight: 1.5,
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: "16px",
              color: "#2196F3",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <UserPlus size={20} />
            Bulk Assign Tickets ({selectedGrievances.length})
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeBulkAssignModal}
            style={{
              padding: 0,
              background: "black",
              border: 0,
              fontSize: "1.5rem",
              fontWeight: 700,
              lineHeight: 1,
              color: "#000",
              textShadow: "0 1px 0 #fff",
              opacity: 0.5,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div
          className="modal-body"
          style={{
            position: "relative",
            flex: "1 1 auto",
            padding: "1.5rem",
            fontFamily: "Poppins",
            fontSize: "14px",
            lineHeight: "1.6",
          }}
        >
          {/* Selected Tickets Info */}
          <div
            style={{
              backgroundColor: "#F8F9FA",
              padding: "12px",
              borderRadius: "6px",
              marginBottom: "15px",
              border: "1px solid #E9ECEF",
            }}
          >
            <div
              style={{
                fontWeight: "600",
                fontSize: "13px",
                color: "#333",
                marginBottom: "8px",
              }}
            >
              Selected Tickets
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#666",
              }}
            >
              {selectedGrievances.length} ticket(s) will be assigned to the selected user
            </div>
          </div>

          {/* User Selection Dropdown */}
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "600",
                marginBottom: "6px",
                color: "#111",
                fontSize: "13px",
              }}
            >
              Assign To <span style={{ color: "red" }}>*</span>
            </label>
            <select
              value={selectedBulkAssignUser}
              onChange={(e) => setSelectedBulkAssignUser(e.target.value)}
              id="bulk-assign-user-select"
              style={{
                width: "100%",
                border: "1px solid #ced4da",
                borderRadius: "6px",
                padding: "8px 10px",
                fontSize: "13px",
                fontWeight: "500",
                fontFamily: "Poppins",
              }}
            >
              <option value="">Select User</option>
              {bulkAssignUsersList.map((user) => (
                <option key={user.id} value={user.id}>
                  {getBulkAssignUserDisplayName(user)}
                </option>
              ))}
            </select>
            {bulkAssignUsersList.length === 0 && (
              <div
                style={{
                  fontSize: "11px",
                  color: "#dc3545",
                  marginTop: "4px",
                }}
              >
                No users available
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div
          className="modal-footer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0.75rem",
            borderTop: "1px solid #dee2e6",
            borderBottomRightRadius: "0.3rem",
            borderBottomLeftRadius: "0.3rem",
            gap: "10px",
          }}
        >
          <button
            type="button"
            onClick={closeBulkAssignModal}
            disabled={isBulkAssigning}
            style={{
              backgroundColor: "#6c757d",
              borderColor: "#6c757d",
              color: "#fff",
              fontSize: "0.875rem",
              lineHeight: 1.5,
              borderRadius: "0.25rem",
              border: "1px solid transparent",
              cursor: isBulkAssigning ? "not-allowed" : "pointer",
              fontFamily: "Poppins",
              opacity: isBulkAssigning ? 0.6 : 1,
              padding: "0.5rem 1rem",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleBulkAssignSubmit}
            disabled={isBulkAssigning || !selectedBulkAssignUser}
            style={{
              backgroundColor: !selectedBulkAssignUser ? "#ccc" : "#2196F3",
              borderColor: !selectedBulkAssignUser ? "#ccc" : "#2196F3",
              color: "#fff",
              fontSize: "0.875rem",
              lineHeight: 1.5,
              borderRadius: "0.25rem",
              border: "1px solid transparent",
              cursor: isBulkAssigning || !selectedBulkAssignUser ? "not-allowed" : "pointer",
              fontFamily: "Poppins",
              opacity: isBulkAssigning ? 0.6 : 1,
              padding: "0.5rem 1rem",
            }}
          >
            {isBulkAssigning ? "Assigning..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
  </div>

      {/* Zebra-striped, borderless table body — same treatment as the Incident List table */}
      <style>{`
        .grievance-mgmt-table .iccc--table tbody tr td,
        .grievance-mgmt-table .iccc--table tbody tr th {
          border: none !important;
        }
        .grievance-mgmt-table .iccc--table tbody tr td {
          background-color: #fff !important;
        }
        .grievance-mgmt-table .iccc--table tbody tr:nth-child(even) td {
          background-color: #F9FAFB !important;
        }
      `}</style>
      <div className="table-section grievance-mgmt-table" style={{ marginTop: "-28px",
      // overflowX: "auto",
    // width: "100%",
    // paddingLeft: "30px",
    paddingRight: "30px"
    }}>
        <ExpandableTablegrievancetable
          data={filteredComplaints}
          title=""
          showFilter={false}
          columns={columns}
          numberOfRows={itemsPerPage}
          showExport={false}
          showReset={false}
          onExpand={false}
          showSearch={false}
          isHeaderFixed={true}
          rowCount={rowCount}
          headerTableHeadStyle={{
            background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
            color: "#FFFFFF",
            fontFamily: "Poppins",
            fontWeight: 600,
            fontSize: "12px",
            lineHeight: "20px",
            position: "sticky", // Ensure sticky positioning
            top: 0,
            zIndex: 1,
          }}
          tableStyle={{
            border: "1px solid #EEF1F5",
            borderRadius: "6px",
            boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
            // minWidth: "1400px", // Add minimum width to enable scroll
            fontFamily: "Poppins",
            // marginTop: -30,
            padding: "0px",
            width: "100%",
          }}
        />
      </div>
      {userProfile?.[0]?.role_name === "Citizen" && (
        <div style={{ marginTop: "8px", padding: "6px 12px", display: "flex", alignItems: "center", gap: "6px" }}>
          <Info size={14} color="#2563eb" style={{ flexShrink: 0 }} />
          <p style={{ fontSize: "12px", color: "#4b5563", margin: 0 }}>
            <strong>Note:</strong> L2 is district level officer responsible for resolving grievance tickets &nbsp;|&nbsp; L3 is the state level officer responsible for resolution.
          </p>
        </div>
      )}
    </div>
  );
};
<style>
{`
  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  .spin-animation {
    animation: spin 1s linear infinite;
  }
`}
</style>


export default GrievanceTable;
